function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
  id: "ProximaNovaACond-Extrabld",
  horizAdvX: "1062"
}, /*#__PURE__*/React.createElement("font-face", {
  fontFamily: "Proxima Nova Alt Cn Th",
  fontWeight: "800",
  unitsPerEm: "2048",
  "panose-1": "2 0 5 6 3 0 0 2 0 4",
  ascent: "1618",
  descent: "-430",
  xHeight: "989",
  capHeight: "1366",
  bbox: "-274 -408 2030 1829",
  underlineThickness: "40",
  underlinePosition: "-312",
  unicodeRange: "U+000D-FB02"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "fi",
  unicode: "fi",
  horizAdvX: "1118",
  d: "M444 0H150v733H23v256h127v43q0 169 84.5 261.5T461 1386q112 0 184-34l-49-228q-21 15-61 15-41 0-66-27t-25-80v-43h160V733H444V0zm426 1083q-72 0-122 50.5T698 1255q0 72 50 122t122 50q71 0 121.5-50t50.5-122q0-71-51-121.5T870 1083zM1018 0H721v989h297V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "fl",
  unicode: "fl",
  horizAdvX: "1196",
  d: "M444 0H150v733H23v256h127v43q0 169 84.5 261.5T461 1386q112 0 184-34l-49-228q-21 15-61 15-41 0-66-27t-25-80v-43h160V733H444V0zm557-25q-280 0-280 283v1108h297V330q0-92 67-92 46 0 68 22l53-229q-67-56-205-56z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: ".notdef",
  horizAdvX: "937",
  d: "M827-184H109v1724h718V-184zm-65 61v1602H172V-123h590z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: ".null",
  horizAdvX: "0"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "nonmarkingreturn",
  horizAdvX: "682"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "NUL",
  horizAdvX: "0"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "NUL",
  horizAdvX: "0"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "CR",
  horizAdvX: "421"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "space",
  horizAdvX: "421"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "exclam",
  unicode: "!",
  horizAdvX: "540",
  d: "M401 465H139l-47 901h354zM270-23q-75 0-128.5 54.5T88 160t53.5 128T270 342t129-54 54-128-54-128.5T270-23z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "quotedbl",
  unicode: "\"",
  horizAdvX: "874",
  d: "M303 745H176q-92 443-92 486 0 64 45.5 109.5T240 1386q64 0 109.5-45t45.5-110q0-19-23-140.5T326 857zm393 0H573q-94 443-94 486 0 64 45.5 109.5T635 1386t110.5-45.5T791 1231q0-19-23.5-140.5T720 857z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "numbersign",
  unicode: "#",
  horizAdvX: "1130",
  d: "M659 0H444l99 340H393L297 0H82l98 340H31l51 184h151l89 316H170l47 184h156l96 342h215l-96-342h149l94 342h216l-97-342h152l-49-184H897l-90-316h160l-52-184H754zm-65 524l90 316H535l-89-316h148z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "dollar",
  unicode: "$",
  horizAdvX: "1067",
  d: "M440-205v185Q188 3 35 156l155 258q62-67 150-106.5T526 268q75 0 117.5 32t42.5 83q0 31-21 56t-56 43-81 34.5-96.5 35.5-101 41.5T234 650t-81 76-56 104.5T76 969q0 147 96 261.5T440 1378v195h215v-191q202-27 342-149L846 981q-127 115-299 115-64 0-98.5-29T414 991q0-32 26-58t69-43.5 97.5-39.5T718 807t111.5-56.5T927 672t69-110 26-150q0-166-97-280T655-12v-193H440z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "percent",
  unicode: "%",
  horizAdvX: "1398",
  d: "M354 702q-142 0-228.5 97T39 1042q0 148 86.5 246t228.5 98q143 0 230.5-98t87.5-246q0-146-87.5-243T354 702zM410 0H266l725 1366h146zm632-25q-142 0-228.5 97T727 315q0 148 86.5 246t228.5 98 230-98 88-246q0-145-88-242.5T1042-25zM354 883q54 0 87.5 42t33.5 117q0 78-33.5 122t-87.5 44q-52 0-84-44t-32-122q0-75 32-117t84-42zm688-729q54 0 87.5 43t33.5 118q0 78-33.5 121t-87.5 43-86-43-32-121q0-75 32.5-118t85.5-43z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ampersand",
  unicode: "&",
  horizAdvX: "1157",
  d: "M1165 0H825q-9 11-30.5 37.5T760 80Q617-25 440-25 266-25 153.5 80T41 375q0 72 20 133t57.5 108 79 81.5T295 766q-80 170-80 283 0 145 102.5 241t257.5 96q141 0 240.5-85t99.5-216q0-42-9-79.5T883.5 939t-37-57.5-45-49T747 789t-57.5-38-62.5-36q41-63 82-121 27-39 77-113 51 108 86 230l234-109q-74-199-164-328 45-57 223-274zM496 205q65 0 127 49-90 120-115 158-53 75-100 151-68-71-68-166 0-81 46-136.5T496 205zm-7 842q0-68 39-154 67 41 101.5 82t34.5 96q0 50-23 78.5t-59 28.5q-43 0-68-35t-25-96z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "quotesingle",
  unicode: "'",
  horizAdvX: "479",
  d: "M303 745H176q-92 443-92 486 0 64 45.5 109.5T240 1386q64 0 109.5-45t45.5-110q0-19-23-140.5T326 857z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "parenleft",
  unicode: "(",
  horizAdvX: "618",
  d: "M580-287L377-408Q240-223 164 14T88 498q0 246 76 483t213 422l203-119q-87-186-128.5-375.5T410 498q0-424 170-785z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "parenright",
  unicode: ")",
  horizAdvX: "620",
  d: "M244-408L41-287Q211 80 211 498q0 219-42 408.5T41 1284l203 119q136-185 211-422t75-483-75-483.5T244-408z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "asterisk",
  unicode: "*",
  horizAdvX: "704",
  d: "M424 735H283l8 221-187-118-69 120 194 103-194 100 69 123 187-119-8 221h141l-12-221 186 119 72-123-197-100 197-103-72-120-186 118z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "plus",
  unicode: "+",
  horizAdvX: "913",
  d: "M854 602H555V254H358v348H59v178h299v332h197V780h299V602z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "comma",
  unicode: ",",
  horizAdvX: "542",
  d: "M465 115q0-119-60-223.5T240-287L115-186q52 28 103 84.5T283 8q-18-6-43-6-64 0-108 45.5T88 164q0 74 52 126t126 52q82 0 140.5-61.5T465 115z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "hyphen",
  unicode: "-",
  horizAdvX: "559",
  d: "M498 371H61v250h437V371z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "period",
  unicode: ".",
  horizAdvX: "540",
  d: "M270-23q-73 0-127.5 54.5T88 160t54 128 128 54q75 0 130-54t55-128-55-128.5T270-23z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "slash",
  unicode: "/",
  horizAdvX: "600",
  d: "M207-41H0l393 1448h207z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "zero",
  unicode: "0",
  horizAdvX: "1132",
  d: "M567-25q-127 0-228 59T176.5 193.5 83 418.5 51 682q0 111 19.5 213.5t61 192 101.5 156T378.5 1348t188.5 38q102 0 187.5-38T899 1243.5t100-156 60.5-192T1079 682q0-110-19.5-212.5t-60.5-193-100-157T754.5 14 567-25zm0 293q96 0 136 103t40 311-40 310-136 102q-98 0-139-102.5T387 682t41-310.5T567 268z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "one",
  unicode: "1",
  horizAdvX: "841",
  d: "M733 0H401v942L199 735 10 932l436 434h287V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "two",
  unicode: "2",
  horizAdvX: "1105",
  d: "M1036 0H82v266q147 130 228 202.5t160.5 148 114 114T648 812t36.5 72 7.5 64q0 64-47 105t-119 41q-168 0-293-144L39 1159q92 112 218 169.5t275 57.5q220 0 357-119t137-317q0-146-101-288.5T571 289h465V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "three",
  unicode: "3",
  horizAdvX: "1097",
  d: "M535-25q-167 0-297.5 60T33 193l192 210q55-63 134-99t161-36q94 0 143.5 40.5T713 412q0 135-205 135-89 0-135-4v295q20-2 127-2 93 0 143.5 31.5T694 961q0 66-50 99.5T508 1094q-77 0-149.5-31.5T233 971L51 1165q81 106 205.5 163.5T537 1386q223 0 352-97t129-275q0-114-78-201T750 705q116-16 202-106.5t86-219.5q0-181-138.5-292.5T535-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "four",
  unicode: "4",
  horizAdvX: "1112",
  d: "M938 0H606v262H41v275l475 829h422V551h133V262H938V0zM606 551v481L334 551h272z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "five",
  unicode: "5",
  horizAdvX: "1122",
  d: "M555-25Q235-25 66 184l194 217q114-133 283-133 90 0 141 50t51 124q0 79-46.5 125.5T557 614q-129 0-217-104l-238 57v799h887v-289H434V791q41 49 107.5 78.5T684 899q167 0 277-120t110-326q0-215-140-346.5T555-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "six",
  unicode: "6",
  horizAdvX: "1116",
  d: "M594-25q-139 0-245 55T179 182.5 83 405 51 680q0 324 160 515t434 191q107 0 203-36t162-99l-154-250q-84 93-207 93-110 0-186-95.5T387 756v-17q41 71 119 115.5T676 899q79 0 150-29.5T952 785t87-141.5 32-192.5q0-210-134.5-343T594-25zm-21 293q75 0 119.5 51.5T737 438q0 91-51 134.5T565 616q-105 0-178-104 3-65 20.5-117t60-89.5T573 268z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "seven",
  unicode: "7",
  horizAdvX: "1011",
  d: "M553 0H195l409 1077H39v289h938v-229z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "eight",
  unicode: "8",
  horizAdvX: "1116",
  d: "M559-25q-228 0-368 99T51 356q0 116 74 212t186 137q-107 37-173 119.5T72 1026q0 92 42 163.5t112.5 113T381 1365t178 21q92 0 176-21t154.5-62.5 112.5-113 42-163.5q0-119-66.5-201T803 705q112-41 187-137.5t75-211.5q0-122-67-209T818.5 17.5 559-25zm0 846q17 3 36 10t41 19.5 39 28 28.5 38T715 965q0 61-42.5 95T559 1094q-73 0-115.5-34T401 965q0-32 17-59t43-43.5 50.5-27T559 821zm0-553q74 0 124 36.5T733 406q0 37-19 68t-48.5 50.5-56.5 31-50 15.5q-34-6-71.5-23.5t-71-55.5-33.5-86q0-65 49-101.5T559 268z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "nine",
  unicode: "9",
  horizAdvX: "1116",
  d: "M473-23q-108 0-204.5 36.5T106 113l154 249q83-92 209-92 114 0 188 95.5T731 606q0 13-2 19-41-71-119-115.5T440 465q-79 0-150 29.5T164 579 77 720.5 45 913q0 210 134.5 343T522 1389q139 0 245-55t170-152.5 96-222.5 32-275q0-324-159.5-515.5T473-23zm78 771q107 0 180 104-3 48-14 89t-31.5 77-56.5 57-84 21q-77 0-120.5-51.5T381 926q0-91 50-134.5T551 748z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "colon",
  unicode: ":",
  horizAdvX: "526",
  d: "M270 637q-74 0-128 54.5T88 821q0 74 54.5 128.5T270 1004q75 0 130-54.5T455 821q0-75-55-129.5T270 637zm0-660q-73 0-127.5 54.5T88 160t54 128 128 54q75 0 130-54t55-128-55-128.5T270-23z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "semicolon",
  unicode: ";",
  horizAdvX: "540",
  d: "M270 637q-73 0-127.5 55T88 821q0 75 54 129t128 54q75 0 130-54t55-129q0-74-55-129t-130-55zm195-512q0-119-60-224T240-279L115-176q52 26 103 83t65 111q-12-8-43-8-64 0-108 45.5T88 172q0 75 52 127.5T266 352q82 0 140.5-62T465 125z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "less",
  unicode: "<",
  horizAdvX: "913",
  d: "M854 248L59 580v213l795 331V911L264 684l590-223V248z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "equal",
  unicode: "=",
  horizAdvX: "913",
  d: "M854 786H59v179h795V786zm0-383H59v179h795V403z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "greater",
  unicode: ">",
  horizAdvX: "913",
  d: "M854 580L59 248v213l590 223L59 911v213l795-331V580z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "question",
  unicode: "?",
  horizAdvX: "806",
  d: "M285 432q-56 68-56 184 0 62 23 113.5t55.5 86 65 65 55.5 63 23 66.5q0 38-28 63t-79 25q-94 0-162-84L23 1219q74 82 172 124.5t208 42.5q176 0 277.5-86T782 1075q0-72-28.5-133.5t-69-103.5-81-80-69-80.5T506 590q0-47 31-82zM406-23q-75 0-130 54.5T221 160t55 128 130 54q74 0 128-54t54-128-54.5-128.5T406-23z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "at",
  unicode: "@",
  horizAdvX: "1476",
  d: "M643-143q-172 0-302.5 78.5T141 152.5 72 469q0 163 63.5 317T304 1054t249 183.5 297 69.5q163 0 290-72t196-198 69-285q0-125-34.5-235t-90-184T1154 216.5 1010 174q-81 0-133 38.5T813 313l-4 17Q702 174 547 174q-116 0-187 80t-71 229q0 135 56.5 258.5t155.5 201 214 77.5q74 0 125.5-34.5T918 893l20 98h262l-102-481q-6-30-6-53 0-86 63-86 54 0 106 105.5t52 273.5q0 219-126.5 346T844 1223q-137 0-265-63.5T359.5 993 213 753t-55-278q0-151 56.5-271.5T385 11t268-72q177 0 344 110l45-63Q848-143 643-143zm29 524q53 0 90 30t72 81l47 235q-13 35-40 60.5T772 813q-63 0-114-47.5t-76-114T557 518q0-63 29.5-100t85.5-37z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "A",
  unicode: "A",
  horizAdvX: "1185",
  d: "M1200 0H842l-51 209H397L344 0H-12l405 1366h400zM725 498l-131 524-133-524h264z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "B",
  unicode: "B",
  horizAdvX: "1189",
  d: "M754 0H109v1366h624q94 0 167.5-29.5t118-79 67-110.5 22.5-129q0-123-63-206T883 705q106-17 176.5-111.5T1130 371q0-161-95.5-266T754 0zM651 838q57 0 88 30.5t31 87.5-31 89-88 32H440V838h211zm8-549q64 0 99 33.5t35 97.5q0 59-35 94t-99 35H440V289h219z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "C",
  unicode: "C",
  horizAdvX: "1173",
  d: "M659-25q-184 0-322.5 90t-212 250T51 682q0 316 165.5 511.5T659 1389q83 0 154-22t121-55.5 92.5-83 69-96T1145 1030L872 913q-29 83-84 133t-129 50q-126 0-198-114t-72-300q0-185 72.5-299.5T659 268q75 0 132 55t81 142l273-117Q1005-25 659-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "D",
  unicode: "D",
  horizAdvX: "1263",
  d: "M590 0H109v1366h479q194 0 335.5-87t214-241 72.5-356q0-308-164.5-495T590 0zm0 289q132 0 207 106t75 287q0 191-72 293t-210 102H440V289h150z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "E",
  unicode: "E",
  horizAdvX: "1007",
  d: "M934 0H109v1366h825v-289H440V838h480V549H440V289h494V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "F",
  unicode: "F",
  horizAdvX: "993",
  d: "M440 0H109v1366h825v-289H440V838h480V549H440V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "G",
  unicode: "G",
  horizAdvX: "1232",
  d: "M637-25q-128 0-236.5 51T215 168.5t-120.5 224T51 682q0 320 166.5 513.5T659 1389q178 0 299.5-95.5T1141 1047L870 924q-29 76-82.5 124T659 1096q-122 0-196-106t-74-308q0-201 74.5-307.5T659 268q87 0 144 63t78 154H614v291h603q0-385-146-593T637-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "H",
  unicode: "H",
  horizAdvX: "1286",
  d: "M1176 0H846v557H440V0H109v1366h331V848h406v518h330V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "I",
  unicode: "I",
  horizAdvX: "548",
  d: "M440 0H109v1366h331V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "J",
  unicode: "J",
  horizAdvX: "878",
  d: "M313-25Q126-25 12 70l111 262q67-64 156-64 73 0 117 43t44 119v936h330V420q0-222-123-333.5T313-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "K",
  unicode: "K",
  horizAdvX: "1183",
  d: "M1192 0H805L528 498l-88-144V0H109v1366h331V791l340 575h385L735 727z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "L",
  unicode: "L",
  horizAdvX: "929",
  d: "M881 0H104v1366h332V289h445V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "M",
  unicode: "M",
  horizAdvX: "1562",
  d: "M1454 0h-328v825L844 0H719L440 825V0H109v1366h438l235-700 238 700h434V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "N",
  unicode: "N",
  horizAdvX: "1284",
  d: "M1176 0H860L440 729V0H109v1366h335l400-694v694h332V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "O",
  unicode: "O",
  horizAdvX: "1304",
  d: "M653-25q-183 0-320.5 91T123 316.5 51 682t72 365.5T332.5 1298t320.5 91q182 0 319-91t209-250.5 72-365.5-72-365.5T972 66 653-25zm0 293q123 0 192.5 115T915 682q0 185-69.5 299.5T653 1096q-125 0-194.5-114.5T389 682q0-184 70-299t194-115z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "P",
  unicode: "P",
  horizAdvX: "1142",
  d: "M440 0H109v1366h548q109 0 196-36t142-98.5 84-143.5 29-173q0-91-29-171t-84-142-142-97.5T657 469H440V0zm176 758q69 0 111.5 43T770 918q0 73-43 116t-111 43H440V758h176z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Q",
  unicode: "Q",
  horizAdvX: "1306",
  d: "M653-25q-183 0-320.5 91T123 316.5 51 682t72 365.5T332.5 1298t320.5 91q182 0 319-91t209-250.5 72-365.5q0-171-51-312t-147-237l49-78L877-82 827 0q-98-25-174-25zm0 293h11L553 453l227 137 92-154q43 108 43 246 0 185-69.5 299.5T653 1096q-125 0-194.5-114.5T389 682q0-184 70-299t194-115z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "R",
  unicode: "R",
  horizAdvX: "1177",
  d: "M1116 0H750L565 469H440V0H109v1366h557q198 0 320-125t122-317q0-83-20.5-153T1033 654.5 962 577t-79-49zM616 758q69 0 111.5 43T770 918t-42.5 116.5T616 1077H440V758h176z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "S",
  unicode: "S",
  horizAdvX: "1054",
  d: "M518-25Q207-25 23 156l155 258q62-67 150-106.5T514 268q75 0 117.5 32t42.5 83q0 35-26.5 62.5t-69 45.5-97.5 39-112.5 41.5T256 627t-97.5 77.5-69 111T63 969q0 83 32 158t91.5 134 152.5 93.5 206 34.5q264 0 440-156L834 981q-127 115-299 115-64 0-99-29t-35-76q0-29 21-52t56-40.5 81-34.5 96.5-37T756 784t96-57 81-76.5T989 547t21-135q0-196-131.5-316.5T518-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "T",
  unicode: "T",
  horizAdvX: "1003",
  d: "M668 0H336v1077H41v289h922v-289H668V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "U",
  unicode: "U",
  horizAdvX: "1292",
  d: "M647-25q-246 0-392 135.5T109 487v879h333V485q0-105 53-162t152-57q97 0 150 57.5T850 485v881h334V489q0-243-145.5-378.5T647-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "V",
  unicode: "V",
  horizAdvX: "1185",
  d: "M793 0H393L-12 1366h356l250-977 248 977h358z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "W",
  unicode: "W",
  horizAdvX: "1632",
  d: "M1311 0H971L815 821 662 0H322L2 1366h354l154-864 178 864h254l180-864 154 864h354z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "X",
  unicode: "X",
  horizAdvX: "1189",
  d: "M1202 0H823L594 444 365 0H-12l399 700-377 666h379l205-416 205 416h379L801 700z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Y",
  unicode: "Y",
  horizAdvX: "1148",
  d: "M741 0H410v555l-426 811h362l229-508 228 508h362L741 555V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Z",
  unicode: "Z",
  horizAdvX: "1019",
  d: "M952 0H68v270l464 807H68v289h870v-264L469 289h483V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "bracketleft",
  unicode: "[",
  horizAdvX: "524",
  d: "M489-389H86v1778h403v-193H297V-197h192v-192z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "backslash",
  unicode: "\\",
  horizAdvX: "600",
  d: "M393-41L0 1407h207L600-41H393z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "bracketright",
  unicode: "]",
  horizAdvX: "524",
  d: "M438-389H37v192h192v1393H37v193h401V-389z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "asciicircum",
  unicode: "^",
  horizAdvX: "804",
  d: "M766 682H555l-154 467-151-467H39l258 684h215z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "underscore",
  unicode: "_",
  horizAdvX: "864",
  d: "M870-274H-6v192h876v-192z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "grave",
  unicode: "`",
  horizAdvX: "468",
  d: "M469 1139H276L0 1434h256z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "a",
  unicode: "a",
  horizAdvX: "1064",
  d: "M965 0H670v117Q624 47 558.5 11T422-25q-170 0-272.5 138T47 496q0 240 102.5 379T422 1014q73 0 138.5-35.5T668 872v117h297V0zM520 238q43 0 85 25.5t65 66.5v329q-24 40-66 66.5T520 752q-80 0-125-70t-45-186q0-118 45-188t125-70z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "b",
  unicode: "b",
  horizAdvX: "1064",
  d: "M395 328q23-40 65-65t83-25q82 0 126 69.5T713 496q0 117-44.5 186.5T543 752q-42 0-83.5-26T395 659V328zm0-328H98v1366h297V872q42 70 108.5 106t139.5 36q169 0 272-139.5T1018 496q0-245-102.5-383T643-25q-73 0-137.5 36T395 117V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "c",
  unicode: "c",
  horizAdvX: "884",
  d: "M522-25q-211 0-343 145.5T47 496t132 374 343 144q115 0 201.5-39T856 879L715 674q-65 78-156 78-94 0-151.5-70.5T350 496q0-116 57.5-187T559 238q92 0 156 77l141-204q-46-57-133-96.5T522-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "d",
  unicode: "d",
  horizAdvX: "1064",
  d: "M965 0H670v117Q624 47 558.5 11T422-25q-170 0-272.5 138T47 496q0 240 102.5 379T422 1014q73 0 139.5-36T670 872v494h295V0zM520 238q43 0 85 25.5t65 66.5v332q-23 40-65 65t-85 25q-80 0-125-70t-45-186q0-118 45-188t125-70z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "e",
  unicode: "e",
  horizAdvX: "999",
  d: "M530-25q-217 0-350 143T47 496q0 144 55.5 261t163 187 248.5 70q208 0 326-145.5T958 483v-86H342q11-80 67-131t154-51q52 0 110.5 23t96.5 63l131-182Q834 49 734 12T530-25zm146 625q-1 32-9.5 61t-27 55.5-51.5 42-78 15.5q-83 0-123.5-51.5T342 600h334z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "f",
  unicode: "f",
  horizAdvX: "622",
  d: "M444 0H150v733H23v256h127v43q0 169 84.5 261.5T461 1386q112 0 184-34l-49-228q-21 15-61 15-41 0-66-27t-25-80v-43h160V733H444V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "g",
  unicode: "g",
  d: "M473-401q-238 0-383 129L201-49q105-105 256-105 88 0 149.5 49.5T668 51v111Q623 92 557.5 55T420 18q-171 0-272 128.5T47 516q0 237 101 367.5T420 1014q74 0 139.5-35.5T668 872v117h297V51q0-104-29.5-185t-77-130T745-345t-132-44-140-12zm47 682q43 0 84 24.5t64 65.5v291q-23 41-64 65.5T520 752q-82 0-126-61t-44-175 44-174.5T520 281z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "h",
  unicode: "h",
  d: "M965 0H668v627q0 67-29.5 96T551 752q-50 0-90.5-30.5T395 647V0H100v1366h295V866q42 60 122 104t171 44q140 0 208.5-72T965 743V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "i",
  unicode: "i",
  horizAdvX: "493",
  d: "M248 1083q-72 0-122 50.5T76 1255q0 72 50 122t122 50q71 0 121.5-50t50.5-122q0-71-51-121.5T248 1083zM395 0H98v989h297V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "j",
  unicode: "j",
  horizAdvX: "493",
  d: "M248 1083q-72 0-122 50.5T76 1255q0 72 50 122t122 50q71 0 121.5-50t50.5-122q0-71-51-121.5T248 1083zM41-401q-66 0-108 12t-83 41l64 227q36-33 90-33 94 0 94 129V989h297V-25q0-179-86-277.5T41-401z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "k",
  unicode: "k",
  horizAdvX: "999",
  d: "M1004 0H657L483 358l-88-129V0H98v1366h297V588l250 401h344L690 547z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "l",
  unicode: "l",
  horizAdvX: "571",
  d: "M379-25Q98-25 98 258v1108h297V330q0-43 17.5-67.5T463 238q45 0 67 22l54-229q-67-56-205-56z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "m",
  unicode: "m",
  horizAdvX: "1583",
  d: "M1483 0h-295v637q0 115-101 115-49 0-88-31.5T938 647V0H643v637q0 115-100 115-48 0-87-31.5T395 647V0H98v989h297V866q32 53 113.5 100.5T678 1014q96 0 160.5-43T926 844q38 68 121.5 119t175.5 51q122 0 191-65.5t69-198.5V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "n",
  unicode: "n",
  d: "M965 0H668v623q0 129-117 129-96 0-156-105V0H98v989h297V866q40 60 120.5 104t172.5 44q139 0 208-73.5T965 741V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "o",
  unicode: "o",
  horizAdvX: "1040",
  d: "M520-25q-148 0-257.5 73.5T100 238.5 47 496q0 105 31.5 198T168 858.5 317 972t203 42 203.5-42T873 858t89-164.5T993 496t-31-198-89-165.5-149.5-115T520-25zm0 263q84 0 126 71.5T688 496q0 114-42 185t-126 71q-83 0-125.5-71.5T352 496q0-115 42.5-186.5T520 238z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "p",
  unicode: "p",
  d: "M643-25q-74 0-139 35.5T395 117v-494H98V989h297V872q44 70 109.5 106t138.5 36q171 0 272-137t101-381q0-242-101.5-381.5T643-25zM543 238q80 0 125 70t45 188q0 117-44.5 186.5T543 752q-42 0-83.5-24.5T395 662V328q21-39 63.5-64.5T543 238z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "q",
  unicode: "q",
  d: "M520 238q41 0 83 25t65 65v334q-23 41-64.5 65.5T520 752q-81 0-125.5-69.5T350 496q0-118 45-188t125-70zM420-25q-170 0-271.5 139.5T47 496q0 244 101 381t272 137q73 0 138.5-36T668 872v117h295V-377H668v494Q624 46 558 10.5T420-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "r",
  unicode: "r",
  horizAdvX: "686",
  d: "M395 0H98v989h297V864q39 62 116 107t148 45V729q-21 8-63 8-54 0-112.5-27.5T395 639V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "s",
  unicode: "s",
  horizAdvX: "872",
  d: "M432-25q-125 0-232.5 39.5T25 119l118 207q53-49 132-84t149-35q63 0 95 21t32 57q0 26-27 43.5T454 358t-95.5 25-105 35.5T158 474t-70 91-27 135q0 132 101.5 223t283.5 91q213 0 367-127L698 682q-39 41-106.5 70.5T451 782q-49 0-81-20t-32-51q0-23 27.5-39t71-28 96.5-25.5T639 581t96.5-58 71-93T834 293q0-140-109.5-229T432-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "t",
  unicode: "t",
  horizAdvX: "641",
  d: "M426-25q-279 0-279 283v475H20v256h127v271h295V989h160V733H442V330q0-43 18-67.5t50-24.5q46 0 68 22l53-229q-67-56-205-56z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "u",
  unicode: "u",
  d: "M963 0H668v119Q626 60 546 17.5T373-25q-138 0-206.5 72.5T98 246v743h297V362q0-124 117-124 50 0 90.5 29t65.5 71v651h295V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "v",
  unicode: "v",
  horizAdvX: "962",
  d: "M639 0H324L-12 989h313l178-633 183 633h313z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "w",
  unicode: "w",
  horizAdvX: "1470",
  d: "M1208 0H895L735 610 575 0H262L-4 989h305l139-610 156 610h270l164-610 139 610h306z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "x",
  unicode: "x",
  horizAdvX: "935",
  d: "M942 0H623L469 297 311 0H-6l287 502L8 989h320l139-278 139 278h320L653 502z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "y",
  unicode: "y",
  d: "M479-401q-235 0-379 129L211-49q47-52 115.5-78.5T465-154q96 0 149.5 54.5T668 51v117q-42-59-122-101T373 25q-138 0-206.5 71.5T98 293v696h297V412q0-127 117-127 50 0 90.5 30t65.5 72v602h295V51q0-210-127-331T479-401z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "z",
  unicode: "z",
  horizAdvX: "860",
  d: "M797 0H61v219l349 514H61v256h727V778L436 256h361V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "braceleft",
  unicode: "{",
  horizAdvX: "542",
  d: "M508-389h-90q-123 0-214 84.5T113-88v373q0 60-27.5 97.5T6 420v160q52 0 79.5 37.5T113 715v370q0 132 91 218t214 86h90v-193h-90q-39 0-66.5-30.5T324 1085V684q0-143-95-184 95-41 95-185V-86q0-49 27.5-80t66.5-31h90v-192z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "bar",
  unicode: "|",
  horizAdvX: "411",
  d: "M301-41H109v1448h192V-41z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "braceright",
  unicode: "}",
  horizAdvX: "542",
  d: "M35-389v192h90q39 0 66.5 31T219-86v401q0 145 94 185-94 40-94 184v401q0 50-27.5 80.5T125 1196H35v193h90q123 0 213-85.5t90-218.5V715q0-60 27.5-97.5T535 580V420q-52 0-79.5-37.5T428 285V-88q0-132-90-216.5T125-389H35z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "asciitilde",
  unicode: "~",
  horizAdvX: "966",
  d: "M719 1366l194-18q-3-55-7.5-99t-14.5-99-23-97-35-84-50-69.5-68-44.5-88-17q-58 0-100.5 26t-63 65-36.5 84-24.5 84-23.5 65-37 26q-41 0-59.5-84.5T252 836L53 854q3 54 8 99t15 99.5 24 97 36 84.5 50 70 68 45 88 17q50 0 88.5-19.5T491 1296t37.5-69 25-76 19-69 22.5-50.5 32-19.5q40 0 60.5 87t31.5 267z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "uni00A0",
  horizAdvX: "421"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "exclamdown",
  unicode: "\xA1",
  horizAdvX: "540",
  d: "M92-377l45 901h264l48-901H92zM86 829q0 74 54.5 128.5T270 1012q74 0 128.5-55T453 829t-54.5-127.5T270 647q-75 0-129.5 54T86 829z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "cent",
  unicode: "\xA2",
  horizAdvX: "884",
  d: "M401-205v195Q239 28 143 164.5T47 496q0 194 96 328.5T401 999v158h211v-151q157-25 244-127L715 674q-65 78-156 78-94 0-151.5-70.5T350 496q0-116 57.5-187T559 238q92 0 156 77l141-204q-37-45-100-79.5T612-16v-189H401z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "sterling",
  unicode: "\xA3",
  horizAdvX: "1040",
  d: "M55 561v187h95Q90 859 90 961q0 94 42 175.5t109.5 135 151 84T561 1386q164 0 277.5-69T997 1112L733 983q-36 135-141 135-61 0-101-45t-40-117q0-42 10.5-83.5t18.5-60 30-64.5h217V561H561q0-5 1-14.5t1-14.5q0-61-32.5-126.5T451 305q44 17 86 17 53 0 118-27t107-27q103 0 156 64l102-262Q982 29 908 2T739-25q-71 0-132.5 21.5t-111 43T403 61q-92 0-210-75L94 207q78 45 127 107t49 128q0 56-24 119H55z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "yen",
  unicode: "\xA5",
  horizAdvX: "1148",
  d: "M741 0H410v229H51v179h359v147H51v178h264l-331 633h362l229-508 228 508h362L834 733h264V555H741V408h357V229H741V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "brokenbar",
  unicode: "\xA6",
  horizAdvX: "411",
  d: "M301-41H109v647h192V-41zm0 801H109v647h192V760z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "section",
  unicode: "\xA7",
  horizAdvX: "882",
  d: "M834 670q0-79-41-148.5T678 410q156-84 156-254 0-143-114-232.5T432-166Q178-166 27-18l116 190q46-48 123-87.5T418 45q63 0 98 26t35 68q0 33-27 56.5T454 235t-95.5 31.5-105 39T158 361t-70 87.5T61 578q0 88 50.5 153T233 827Q61 911 61 1092q0 128 105 211t268 83q239 0 377-131l-113-176q-106 103-239 103-57 0-89-23t-32-63q0-29 27.5-50.5t71-36T533 980t106-38.5 96.5-55.5 71-87.5T834 670zm-275-66q0 104-119 144-108-25-108-119 0-54 37-87t108-57q82 39 82 119z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "dieresis",
  unicode: "\xA8",
  horizAdvX: "604",
  d: "M655 1255q0-63-44.5-107T502 1104q-63 0-107.5 44T350 1255q0 64 44.5 109t107.5 45q64 0 108.5-44.5T655 1255zm-401 0q0-63-44.5-107T102 1104q-64 0-108.5 44T-51 1255q0 65 44.5 109.5T102 1409q63 0 107.5-45t44.5-109z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "copyright",
  unicode: "\xA9",
  horizAdvX: "1593",
  d: "M1503 684q0-143-56-274t-150-226-225-151-275-56q-191 0-354 95T185 330 90 684q0 192 95 355t258 257.5 354 94.5q144 0 275-56t225-150.5T1447 959t56-275zm-78 0q0 127-50 243.5t-134 201-200.5 134.5-243.5 50q-169 0-314-84.5T253 999t-85-315q0-169 85-314t230-230 314-85q127 0 243.5 50.5t200.5 135T1375 441t50 243zm-378-223l69-68Q996 254 809 254q-179 0-302.5 123T383 686q0 185 123.5 307.5T809 1116q188 0 305-137l-67-68q-40 54-103 85.5T809 1028q-136 0-231-96.5T483 686q0-148 95.5-247T809 340q72 0 134.5 33t103.5 88z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ordfeminine",
  unicode: "\xAA",
  horizAdvX: "720",
  d: "M639 668H428v63q-24-33-69.5-56.5T250 651q-84 0-145.5 55T43 862q0 99 61.5 153t145.5 54q122 0 178-72v68q0 48-31 76t-86 28q-86 0-161-75l-76 137q54 48 130 72t148 24q60 0 110-13.5t90.5-41.5 63.5-78 23-117V668zM336 784q65 0 92 50v63q-27 49-92 49-36 0-60-21.5T252 866q0-40 23.5-61t60.5-21z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "guillemotleft",
  unicode: "\xAB",
  horizAdvX: "1007",
  d: "M946 129H700L444 498l256 362h246L690 498zm-383 0H317L61 498l256 362h246L307 498z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "logicalnot",
  unicode: "\xAC",
  horizAdvX: "927",
  d: "M854 965V403H670v383H59v179h795z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "registered",
  unicode: "\xAE",
  horizAdvX: "1011",
  d: "M940 952q0-180-126.5-307T506 518q-180 0-307 127T72 952q0 181 127 307.5T506 1386q119 0 219-57.5T882.5 1171 940 952zm-68 0q0 154-107 260.5T506 1319q-153 0-260-107T139 952q0-151 107.5-258.5T506 586t259 107.5T872 952zM713 702h-90L494 899h-82V702h-74v498h203q66 0 116-42.5t50-108.5q0-72-46-110t-81-38zm-82 347q0 39-28 64.5t-62 25.5H412V963h129q34 0 62 24.5t28 61.5z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "macron",
  unicode: "\xAF",
  horizAdvX: "643",
  d: "M643 1210H0v164h643v-164z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "degree",
  unicode: "\xB0",
  horizAdvX: "649",
  d: "M610 1100q0-118-83.5-201.5T324 815q-118 0-201.5 83.5T39 1100q0 119 83.5 202.5T324 1386t202-84 84-202zm-155 0q0 54-38.5 92.5T324 1231t-90.5-38.5T197 1100t36.5-90.5T324 973t92.5 36.5T455 1100z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "plusminus",
  unicode: "\xB1",
  horizAdvX: "913",
  d: "M854 635H555V287H358v348H59v178h299v334h197V813h299V635zm0-621H59v179h795V14z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "twosuperior",
  unicode: "\xB2",
  horizAdvX: "731",
  d: "M684 862H72v160q173 138 252 209t107 112 28 82q0 43-29.5 68t-79.5 25q-53 0-103-27.5t-81-69.5L45 1556q58 69 140.5 103.5T360 1694q144 0 231-67.5t87-188.5q0-88-69-176t-240-224h315V862z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "threesuperior",
  unicode: "\xB3",
  horizAdvX: "731",
  d: "M684 1092q0-110-88.5-177T362 848q-107 0-190.5 35T41 977l121 139q37-44 89-68t101-24q57 0 87 23t30 59q0 49-36.5 67.5T332 1192q-66 0-78-2v172q12-2 72-2 131 0 131 80 0 78-113 78-110 0-178-82L51 1561q111 133 311 133 146 0 228-60t82-166q0-67-48.5-119.5T504 1284q73-8 126.5-61t53.5-131z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "acute",
  unicode: "\xB4",
  horizAdvX: "468",
  d: "M469 1434l-276-295H0l215 295h254z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "mu",
  unicode: "\xB5",
  d: "M395-377H98V989h297V362q0-126 117-126 50 0 90.5 30t65.5 72v651h295V0H668v119q-40-56-114-98T395-25v-352z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "paragraph",
  unicode: "\xB6",
  horizAdvX: "919",
  d: "M840-205H700v1432H547V-205H408v867q-146 0-249.5 103T55 1014t103.5 249T408 1366h432V-205z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "periodcentered",
  unicode: "\xB7",
  horizAdvX: "540",
  d: "M453 500q0-74-54-128.5T270 317t-128.5 54.5T88 500q0 75 53.5 129.5T270 684t129-54.5T453 500z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "cedilla",
  unicode: "\xB8",
  horizAdvX: "430",
  d: "M209-403q-62 0-118.5 19T0-336l53 111q76-60 150-60 37 0 61.5 17t24.5 45q0 47-47 47-32 0-56-27L84-143l61 166h142l-54-125q29 20 66 20 55 0 93-41t38-104q0-81-62.5-128.5T209-403z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "onesuperior",
  unicode: "\xB9",
  horizAdvX: "579",
  d: "M481 862H260v539l-125-127-125 131 281 276h190V862z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ordmasculine",
  unicode: "\xBA",
  horizAdvX: "743",
  d: "M371 651q-150 0-238 98.5T45 989t88 239.5 238 98.5q153 0 240-98t87-240-87-240-240-98zm0 168q110 0 110 170 0 166-110 166-53 0-80-43.5T264 989q0-80 27-125t80-45z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "guillemotright",
  unicode: "\xBB",
  horizAdvX: "1007",
  d: "M563 498L307 129H61l256 369L61 860h246zm383 0L690 129H444l256 369-256 362h246z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "onequarter",
  unicode: "\xBC",
  horizAdvX: "1589",
  d: "M1204 1366L477 0H336l725 1366h143zm352-1200h-83V0h-220v166H895v158l291 495h287V338h83V166zm-303 172v272l-157-272h157zM481 547H260v538L135 958 10 1090l281 276h190V547z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "onehalf",
  unicode: "\xBD",
  horizAdvX: "1660",
  d: "M1204 1366L477 0H336l725 1366h143zM1614 0h-613v160q173 138 252 209t107.5 112 28.5 82q0 43-29.5 67.5T1280 655q-54 0-103.5-27t-80.5-69L975 694q117 137 315 137 144 0 231-67.5t87-188.5q0-87-69.5-174.5T1298 176h316V0zM481 547H260v538L135 958 10 1090l281 276h190V547z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "threequarters",
  unicode: "\xBE",
  horizAdvX: "1710",
  d: "M1325 1366L598 0H457l725 1366h143zm352-1200h-84V0h-219v166h-358v158l291 495h286V338h84V166zm-303 172v272l-157-272h157zM684 776q0-110-88.5-177T362 532q-107 0-190 35.5T41 662l121 139q37-44 89-68t101-24q57 0 87 23t30 59q0 49-36.5 67.5T332 877q-60 0-78-3v173q18-3 72-3 131 0 131 80 0 78-113 78-110 0-178-82L51 1245q111 133 311 133 146 0 228-59.5t82-165.5q0-67-48.5-119.5T504 969q73-8 126.5-61.5T684 776z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "questiondown",
  unicode: "\xBF",
  horizAdvX: "714",
  d: "M522 555q56-68 56-184 0-62-23-113.5t-55.5-86-65-64-55.5-62T356-20q0-39 27.5-65t79.5-26q95 0 162 86l159-206q-74-82-172.5-125T403-399q-176 0-277 86T25-88q0 72 28.5 133.5t69 104 81 80.5 69 80.5T301 397q0 47-31 82zm-121 457q75 0 130-54.5T586 829t-55-128-130-54q-73 0-127.5 54.5T219 829q0 74 54.5 128.5T401 1012z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Agrave",
  unicode: "\xC0",
  horizAdvX: "1185",
  d: "M758 1491H565l-276 295h256zM1200 0H842l-51 209H397L344 0H-12l405 1366h400zM725 498l-131 524-133-524h264z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Aacute",
  unicode: "\xC1",
  horizAdvX: "1185",
  d: "M901 1786l-276-295H432l215 295h254zM1200 0H842l-51 209H397L344 0H-12l405 1366h400zM725 498l-131 524-133-524h264z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Acircumflex",
  unicode: "\xC2",
  horizAdvX: "1185",
  d: "M883 1491H715l-123 172-117-172H307l154 295h262zM1200 0H842l-51 209H397L344 0H-12l405 1366h400zM725 498l-131 524-133-524h264z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Atilde",
  unicode: "\xC3",
  horizAdvX: "1185",
  d: "M696 1487q-33 0-60.5 12.5t-45 30.5-32.5 36.5-31.5 31T494 1610q-27 0-43.5-28t-16.5-83H283q0 128 55 201.5t154 73.5q33 0 60.5-12.5t45-31 33-36.5 32-30.5T696 1651q26 0 43 28t17 82h149q0-129-54.5-201.5T696 1487zM1200 0H842l-51 209H397L344 0H-12l405 1366h400zM725 498l-131 524-133-524h264z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Adieresis",
  unicode: "\xC4",
  horizAdvX: "1185",
  d: "M946 1612q0-63-44.5-107.5T793 1460q-63 0-107.5 44.5T641 1612q0 64 44.5 108.5T793 1765q65 0 109-44.5t44-108.5zm-401 0q0-63-44.5-107.5T393 1460q-64 0-108.5 44.5T240 1612q0 64 44 108.5t109 44.5q63 0 107.5-44.5T545 1612zM1200 0H842l-51 209H397L344 0H-12l405 1366h400zM725 498l-131 524-133-524h264z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Aring",
  unicode: "\xC5",
  horizAdvX: "1185",
  d: "M594 1419q-85 0-145 60t-60 145 60 145 145 60 144-60 59-145-59-145-144-60zm0 127q32 0 55 23t23 55-23 55-55 23-55-23-23-55 23-55 55-23zM1200 0H842l-51 209H397L344 0H-12l405 1366h400zM725 498l-131 524-133-524h264z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "AE",
  unicode: "\xC6",
  horizAdvX: "1656",
  d: "M1595 0H770v209H430L342 0H-16l647 1366h964v-289h-493V838h479V549h-479V289h493V0zM770 498v524L547 498h223z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Ccedilla",
  unicode: "\xC7",
  horizAdvX: "1173",
  d: "M647-395q-62 0-118.5 19T438-328l54 111q75-59 149-59 37 0 61.5 16.5T727-215q0 47-47 47-31 0-55-27l-103 60 43 117Q328 16 189.5 205.5T51 682q0 316 165.5 511.5T659 1389q83 0 154-22t121-55.5 92.5-83 69-96T1145 1030L872 913q-29 83-84 133t-129 50q-126 0-198-114t-72-300q0-185 72.5-299.5T659 268q75 0 132 55t81 142l273-117Q1012-2 700-23l-28-71q29 20 65 20 55 0 93-41t38-104q0-81-62.5-128.5T647-395z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Egrave",
  unicode: "\xC8",
  horizAdvX: "1007",
  d: "M688 1491H496l-277 295h256zM934 0H109v1366h825v-289H440V838h480V549H440V289h494V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Eacute",
  unicode: "\xC9",
  horizAdvX: "1007",
  d: "M834 1786l-277-295H365l215 295h254zM934 0H109v1366h825v-289H440V838h480V549H440V289h494V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Ecircumflex",
  unicode: "\xCA",
  horizAdvX: "1007",
  d: "M809 1491H641l-123 172-117-172H233l154 295h262zM934 0H109v1366h825v-289H440V838h480V549H440V289h494V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Edieresis",
  unicode: "\xCB",
  horizAdvX: "1007",
  d: "M879 1612q0-63-45-107.5T725 1460q-63 0-107.5 44.5T573 1612q0 64 44.5 108.5T725 1765q65 0 109.5-44.5T879 1612zm-402 0q0-63-44-107.5T326 1460q-64 0-109 44.5T172 1612q0 64 44.5 108.5T326 1765q63 0 107-44.5t44-108.5zM934 0H109v1366h825v-289H440V838h480V549H440V289h494V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Igrave",
  unicode: "\xCC",
  horizAdvX: "548",
  d: "M436 1491H244l-277 295h256zM440 0H109v1366h331V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Iacute",
  unicode: "\xCD",
  horizAdvX: "548",
  d: "M586 1786l-277-295H117l215 295h254zM440 0H109v1366h331V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Icircumflex",
  unicode: "\xCE",
  horizAdvX: "548",
  d: "M561 1491H393l-123 172-116-172H-14l153 295h262zM440 0H109v1366h331V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Idieresis",
  unicode: "\xCF",
  horizAdvX: "548",
  d: "M629 1612q0-63-45-107.5T475 1460q-63 0-107 44.5T324 1612q0 64 44 108.5t107 44.5q65 0 109.5-44.5T629 1612zm-402 0q0-63-44-107.5T76 1460q-64 0-109 44.5T-78 1612q0 64 44.5 108.5T76 1765q63 0 107-44.5t44-108.5zM440 0H109v1366h331V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Eth",
  unicode: "\xD0",
  horizAdvX: "1312",
  d: "M639 0H158v551H20v248h138v567h479q291 0 457-188t166-496-165-495T639 0zm57 551H489V289h150q133 0 208 106t75 287q0 191-72.5 293T639 1077H489V799h207V551z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Ntilde",
  unicode: "\xD1",
  horizAdvX: "1284",
  d: "M743 1487q-33 0-60.5 12.5t-45 30.5-32.5 36.5-31.5 31T541 1610q-27 0-43.5-28t-16.5-83H330q0 128 55 201.5t154 73.5q33 0 60.5-12.5t45-31 33-36.5 32-30.5T743 1651q26 0 43 28t17 82h149q0-129-54.5-201.5T743 1487zM1176 0H860L440 729V0H109v1366h335l400-694v694h332V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Ograve",
  unicode: "\xD2",
  horizAdvX: "1304",
  d: "M819 1491H627l-277 295h256zM653-25q-183 0-320.5 91T123 316.5 51 682t72 365.5T332.5 1298t320.5 91q182 0 319-91t209-250.5 72-365.5-72-365.5T972 66 653-25zm0 293q123 0 192.5 115T915 682q0 185-69.5 299.5T653 1096q-125 0-194.5-114.5T389 682q0-184 70-299t194-115z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Oacute",
  unicode: "\xD3",
  horizAdvX: "1304",
  d: "M961 1786l-277-295H492l215 295h254zM653-25q-183 0-320.5 91T123 316.5 51 682t72 365.5T332.5 1298t320.5 91q182 0 319-91t209-250.5 72-365.5-72-365.5T972 66 653-25zm0 293q123 0 192.5 115T915 682q0 185-69.5 299.5T653 1096q-125 0-194.5-114.5T389 682q0-184 70-299t194-115z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Ocircumflex",
  unicode: "\xD4",
  horizAdvX: "1304",
  d: "M944 1491H776l-123 172-116-172H369l153 295h262zM653-25q-183 0-320.5 91T123 316.5 51 682t72 365.5T332.5 1298t320.5 91q182 0 319-91t209-250.5 72-365.5-72-365.5T972 66 653-25zm0 293q123 0 192.5 115T915 682q0 185-69.5 299.5T653 1096q-125 0-194.5-114.5T389 682q0-184 70-299t194-115z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Otilde",
  unicode: "\xD5",
  horizAdvX: "1304",
  d: "M756 1487q-33 0-60.5 12.5T650 1530t-33 36.5-31.5 31T553 1610q-59 0-59-111H342q0 128 55 201.5t154 73.5q33 0 60.5-12.5t45.5-31 33.5-36.5 32-30.5T756 1651q26 0 42.5 28t16.5 82h150q0-129-54.5-201.5T756 1487zM653-25q-183 0-320.5 91T123 316.5 51 682t72 365.5T332.5 1298t320.5 91q182 0 319-91t209-250.5 72-365.5-72-365.5T972 66 653-25zm0 293q123 0 192.5 115T915 682q0 185-69.5 299.5T653 1096q-125 0-194.5-114.5T389 682q0-184 70-299t194-115z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Odieresis",
  unicode: "\xD6",
  horizAdvX: "1304",
  d: "M1008 1612q0-63-45-107.5T854 1460q-63 0-107.5 44.5T702 1612q0 64 44.5 108.5T854 1765q65 0 109.5-44.5T1008 1612zm-402 0q0-63-44-107.5T455 1460q-64 0-109 44.5T301 1612q0 64 44.5 108.5T455 1765q63 0 107-44.5t44-108.5zM653-25q-183 0-320.5 91T123 316.5 51 682t72 365.5T332.5 1298t320.5 91q182 0 319-91t209-250.5 72-365.5-72-365.5T972 66 653-25zm0 293q123 0 192.5 115T915 682q0 185-69.5 299.5T653 1096q-125 0-194.5-114.5T389 682q0-184 70-299t194-115z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "multiply",
  unicode: "\xD7",
  horizAdvX: "913",
  d: "M698 317L457 559 217 317 90 444l242 240L90 924l127 127 240-242 241 242 127-127-241-240 241-240z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Oslash",
  unicode: "\xD8",
  horizAdvX: "1304",
  d: "M653-25q-177 0-315 86L297 0H90l119 178Q51 372 51 682q0 206 72 365.5T332.5 1298t320.5 91q167 0 299-80l39 57h207l-113-170q168-193 168-514 0-206-72-365.5T972 66 653-25zm0 293q123 0 192.5 115T915 682q0 120-30 211L510 322q60-54 143-54zM389 682q0-107 25-193l370 562q-57 45-131 45-125 0-194.5-114.5T389 682z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Ugrave",
  unicode: "\xD9",
  horizAdvX: "1292",
  d: "M813 1491H621l-277 295h256zM647-25q-246 0-392 135.5T109 487v879h333V485q0-105 53-162t152-57q97 0 150 57.5T850 485v881h334V489q0-243-145.5-378.5T647-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Uacute",
  unicode: "\xDA",
  horizAdvX: "1292",
  d: "M956 1786l-276-295H487l215 295h254zM647-25q-246 0-392 135.5T109 487v879h333V485q0-105 53-162t152-57q97 0 150 57.5T850 485v881h334V489q0-243-145.5-378.5T647-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Ucircumflex",
  unicode: "\xDB",
  horizAdvX: "1292",
  d: "M942 1491H774l-123 172-116-172H367l153 295h262zM647-25q-246 0-392 135.5T109 487v879h333V485q0-105 53-162t152-57q97 0 150 57.5T850 485v881h334V489q0-243-145.5-378.5T647-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Udieresis",
  unicode: "\xDC",
  horizAdvX: "1292",
  d: "M1001 1612q0-63-44.5-107.5T848 1460q-63 0-107.5 44.5T696 1612q0 64 44.5 108.5T848 1765q64 0 108.5-44.5T1001 1612zm-401 0q0-63-44-107.5T449 1460q-64 0-109 44.5T295 1612q0 64 44.5 108.5T449 1765q63 0 107-44.5t44-108.5zM647-25q-246 0-392 135.5T109 487v879h333V485q0-105 53-162t152-57q97 0 150 57.5T850 485v881h334V489q0-243-145.5-378.5T647-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Yacute",
  unicode: "\xDD",
  horizAdvX: "1148",
  d: "M885 1786l-277-295H416l215 295h254zM741 0H410v555l-426 811h362l229-508 228 508h362L741 555V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Thorn",
  unicode: "\xDE",
  horizAdvX: "1142",
  d: "M440 0H109v1366h331v-213h217q109 0 196-36t142-98.5 84-143.5 29-173-29-172-84-141.5-142-97T657 256H440V0zm176 545q69 0 111.5 42.5T770 702q0 74-43 118t-111 44H440V545h176z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "germandbls",
  unicode: "\xDF",
  horizAdvX: "1249",
  d: "M1223 297q0-134-107-228T840-25q-124 0-209.5 37.5T469 123l109 203q38-46 101-80.5T809 211q55 0 85 21t30 57q0 25-23.5 43.5T839 365t-83.5 29-91 38.5-83.5 55-61.5 84.5T496 694q0 56 21.5 102.5t52 76.5 61.5 55 52.5 51.5T705 1032q0 42-39.5 67t-96.5 25q-77 0-123.5-42T399 958V0H102v958q0 180 127.5 304T571 1386q114 0 213.5-39.5T946 1234t62-163q0-63-23.5-114t-57-82-67-56.5-57-51.5-23.5-52q0-23 24.5-39.5T868 647t86.5-26 94.5-38 86-57.5 63.5-92.5 24.5-136z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "agrave",
  unicode: "\xE0",
  horizAdvX: "1064",
  d: "M702 1139H510l-277 295h256zM965 0H670v117Q624 47 558.5 11T422-25q-170 0-272.5 138T47 496q0 240 102.5 379T422 1014q73 0 138.5-35.5T668 872v117h297V0zM520 238q43 0 85 25.5t65 66.5v329q-24 40-66 66.5T520 752q-80 0-125-70t-45-186q0-118 45-188t125-70z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "aacute",
  unicode: "\xE1",
  horizAdvX: "1064",
  d: "M846 1434l-277-295H377l215 295h254zM965 0H670v117Q624 47 558.5 11T422-25q-170 0-272.5 138T47 496q0 240 102.5 379T422 1014q73 0 138.5-35.5T668 872v117h297V0zM520 238q43 0 85 25.5t65 66.5v329q-24 40-66 66.5T520 752q-80 0-125-70t-45-186q0-118 45-188t125-70z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "acircumflex",
  unicode: "\xE2",
  horizAdvX: "1064",
  d: "M829 1139H662l-123 172-117-172H254l154 295h262zM965 0H670v117Q624 47 558.5 11T422-25q-170 0-272.5 138T47 496q0 240 102.5 379T422 1014q73 0 138.5-35.5T668 872v117h297V0zM520 238q43 0 85 25.5t65 66.5v329q-24 40-66 66.5T520 752q-80 0-125-70t-45-186q0-118 45-188t125-70z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "atilde",
  unicode: "\xE3",
  horizAdvX: "1064",
  d: "M645 1135q-40 0-73 19t-50.5 42-38.5 42-41 19q-59 0-59-110H231q0 128 55 201t154 73q33 0 60.5-12.5T546 1378t33.5-36.5 32-31T645 1298q26 0 43 28.5t17 82.5h149q0-129-54.5-201.5T645 1135zM965 0H670v117Q624 47 558.5 11T422-25q-170 0-272.5 138T47 496q0 240 102.5 379T422 1014q73 0 138.5-35.5T668 872v117h297V0zM520 238q43 0 85 25.5t65 66.5v329q-24 40-66 66.5T520 752q-80 0-125-70t-45-186q0-118 45-188t125-70z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "adieresis",
  unicode: "\xE4",
  horizAdvX: "1064",
  d: "M895 1255q0-63-45-107t-109-44q-63 0-107 44t-44 107q0 64 44 109t107 45q65 0 109.5-44.5T895 1255zm-401 0q0-63-44.5-107T342 1104q-64 0-109 44t-45 107q0 65 45 109.5t109 44.5q63 0 107.5-45t44.5-109zM965 0H670v117Q624 47 558.5 11T422-25q-170 0-272.5 138T47 496q0 240 102.5 379T422 1014q73 0 138.5-35.5T668 872v117h297V0zM520 238q43 0 85 25.5t65 66.5v329q-24 40-66 66.5T520 752q-80 0-125-70t-45-186q0-118 45-188t125-70z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "aring",
  unicode: "\xE5",
  horizAdvX: "1064",
  d: "M541 1118q-85 0-145 60t-60 145 60 145 145 60q84 0 143-60t59-145-59-145-143-60zm0 127q32 0 54.5 23t22.5 55-22.5 55-54.5 23-55-23-23-55 23-55 55-23zM965 0H670v117Q624 47 558.5 11T422-25q-170 0-272.5 138T47 496q0 240 102.5 379T422 1014q73 0 138.5-35.5T668 872v117h297V0zM520 238q43 0 85 25.5t65 66.5v329q-24 40-66 66.5T520 752q-80 0-125-70t-45-186q0-118 45-188t125-70z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ae",
  unicode: "\xE6",
  horizAdvX: "1622",
  d: "M965 0H670v117Q624 47 558.5 11T422-25q-170 0-272.5 138T47 496q0 240 102.5 379T422 1014q73 0 138.5-35.5T668 872v117h297V870q80 144 249 144 172 0 270.5-145.5T1583 483v-86H965q10-79 65.5-127.5T1184 221q52 0 110.5 23t96.5 63l131-196q-50-62-125.5-99T1239-25q-189 0-274 148V0zM520 238q43 0 85 25.5t65 66.5v329q-24 40-66 66.5T520 752q-80 0-125-70t-45-186q0-118 45-188t125-70zm780 362q-4 72-43 123t-124 51q-57 0-95.5-28t-54-64.5T965 600h335z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ccedilla",
  unicode: "\xE7",
  horizAdvX: "884",
  d: "M524-399q-62 0-118.5 19T315-332l54 111q76-60 149-60 37 0 61.5 17t24.5 45q0 47-47 47-31 0-55-27l-103 60 45 121Q263 8 155 147.5T47 496q0 230 132 374t343 144q115 0 201.5-39T856 879L715 674q-65 78-156 78-94 0-151.5-70.5T350 496q0-116 57.5-187T559 238q92 0 156 77l141-204q-40-48-111-84.5T582-20l-33-78q29 20 65 20 55 0 93-41t38-104q0-81-62.5-128.5T524-399z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "egrave",
  unicode: "\xE8",
  horizAdvX: "999",
  d: "M530-25q-217 0-350 143T47 496q0 144 55.5 261t163 187 248.5 70q208 0 326-145.5T958 483v-86H342q11-80 67-131t154-51q52 0 110.5 23t96.5 63l131-182Q834 49 734 12T530-25zm146 625q-1 32-9.5 61t-27 55.5-51.5 42-78 15.5q-83 0-123.5-51.5T342 600h334zm2 539H485l-276 295h256z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "eacute",
  unicode: "\xE9",
  horizAdvX: "999",
  d: "M530-25q-217 0-350 143T47 496q0 144 55.5 261t163 187 248.5 70q208 0 326-145.5T958 483v-86H342q11-80 67-131t154-51q52 0 110.5 23t96.5 63l131-182Q834 49 734 12T530-25zm146 625q-1 32-9.5 61t-27 55.5-51.5 42-78 15.5q-83 0-123.5-51.5T342 600h334zm149 834l-276-295H356l215 295h254z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ecircumflex",
  unicode: "\xEA",
  horizAdvX: "999",
  d: "M530-25q-217 0-350 143T47 496q0 144 55.5 261t163 187 248.5 70q208 0 326-145.5T958 483v-86H342q11-80 67-131t154-51q52 0 110.5 23t96.5 63l131-182Q834 49 734 12T530-25zm146 625q-1 32-9.5 61t-27 55.5-51.5 42-78 15.5q-83 0-123.5-51.5T342 600h334zm123 539H631l-123 172-117-172H223l154 295h262z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "edieresis",
  unicode: "\xEB",
  horizAdvX: "999",
  d: "M530-25q-217 0-350 143T47 496q0 144 55.5 261t163 187 248.5 70q208 0 326-145.5T958 483v-86H342q11-80 67-131t154-51q52 0 110.5 23t96.5 63l131-182Q834 49 734 12T530-25zm146 625q-1 32-9.5 61t-27 55.5-51.5 42-78 15.5q-83 0-123.5-51.5T342 600h334zm188 655q0-63-44.5-107T711 1104q-63 0-107.5 44T559 1255q0 64 44.5 109t107.5 45q64 0 108.5-44.5T864 1255zm-401 0q0-63-44.5-107T311 1104q-64 0-108.5 44T158 1255q0 65 44.5 109.5T311 1409q63 0 107.5-45t44.5-109z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "igrave",
  unicode: "\xEC",
  horizAdvX: "493",
  d: "M410 1139H217l-276 295h256zM395 0H98v989h297V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "iacute",
  unicode: "\xED",
  horizAdvX: "493",
  d: "M553 1434l-277-295H84l215 295h254zM395 0H98v989h297V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "icircumflex",
  unicode: "\xEE",
  horizAdvX: "493",
  d: "M537 1139H369l-123 172-117-172H-39l154 295h262zM395 0H98v989h297V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "idieresis",
  unicode: "\xEF",
  horizAdvX: "493",
  d: "M600 1255q0-63-45-107t-109-44q-63 0-107 44t-44 107q0 64 44 109t107 45q64 0 109-44.5t45-109.5zm-401 0q0-63-44.5-107T47 1104q-64 0-108.5 44t-44.5 107q0 65 44.5 109.5T47 1409q63 0 107.5-45t44.5-109zM395 0H98v989h297V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "eth",
  unicode: "\xF0",
  horizAdvX: "1040",
  d: "M252 969l-57 133 206 92q-50 51-100 94l209 178q97-86 160-155l172 75 57-129-135-61q229-305 229-647 0-267-122.5-420.5T520-25q-146 0-255 65T101.5 213 47 455q0 132 47.5 240.5T229 867t197 63q172 0 266-170-45 154-186 321zm268-731q83 0 125.5 59.5T688 453t-42.5 156.5T520 670q-81 0-124.5-61T352 453t43-155 125-60z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ntilde",
  unicode: "\xF1",
  d: "M973 0H676v623q0 129-117 129-96 0-156-105V0H106v989h297V866q40 60 120.5 104t172.5 44q139 0 208-73.5T973 741V0zM635 1135q-40 0-73 19t-50.5 42-38.5 42-41 19q-59 0-59-110H221q0 128 55 201t154 73q33 0 60.5-12.5T536 1378t33.5-36.5 32-31T635 1298q26 0 42.5 28t16.5 83h150q0-129-54.5-201.5T635 1135z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ograve",
  unicode: "\xF2",
  horizAdvX: "1040",
  d: "M520-25q-148 0-257.5 73.5T100 238.5 47 496q0 105 31.5 198T168 858.5 317 972t203 42 203.5-42T873 858t89-164.5T993 496t-31-198-89-165.5-149.5-115T520-25zm0 263q84 0 126 71.5T688 496q0 114-42 185t-126 71q-83 0-125.5-71.5T352 496q0-115 42.5-186.5T520 238zm164 901H492l-277 295h256z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "oacute",
  unicode: "\xF3",
  horizAdvX: "1040",
  d: "M520-25q-148 0-257.5 73.5T100 238.5 47 496q0 105 31.5 198T168 858.5 317 972t203 42 203.5-42T873 858t89-164.5T993 496t-31-198-89-165.5-149.5-115T520-25zm0 263q84 0 126 71.5T688 496q0 114-42 185t-126 71q-83 0-125.5-71.5T352 496q0-115 42.5-186.5T520 238zm307 1196l-276-295H358l215 295h254z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ocircumflex",
  unicode: "\xF4",
  horizAdvX: "1040",
  d: "M520-25q-148 0-257.5 73.5T100 238.5 47 496q0 105 31.5 198T168 858.5 317 972t203 42 203.5-42T873 858t89-164.5T993 496t-31-198-89-165.5-149.5-115T520-25zm0 263q84 0 126 71.5T688 496q0 114-42 185t-126 71q-83 0-125.5-71.5T352 496q0-115 42.5-186.5T520 238zm291 901H643l-123 172-117-172H236l153 295h262z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "otilde",
  unicode: "\xF5",
  horizAdvX: "1040",
  d: "M520-25q-148 0-257.5 73.5T100 238.5 47 496q0 105 31.5 198T168 858.5 317 972t203 42 203.5-42T873 858t89-164.5T993 496t-31-198-89-165.5-149.5-115T520-25zm0 263q84 0 126 71.5T688 496q0 114-42 185t-126 71q-83 0-125.5-71.5T352 496q0-115 42.5-186.5T520 238zm103 897q-40 0-73 19t-50.5 42-38.5 42-41 19q-27 0-43.5-27.5T360 1147H209q0 128 55 201t154 73q33 0 60.5-12.5T524 1378t33.5-36.5 32-31T623 1298q26 0 42.5 28t16.5 83h149q0-129-54-201.5T623 1135z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "odieresis",
  unicode: "\xF6",
  horizAdvX: "1040",
  d: "M520-25q-148 0-257.5 73.5T100 238.5 47 496q0 105 31.5 198T168 858.5 317 972t203 42 203.5-42T873 858t89-164.5T993 496t-31-198-89-165.5-149.5-115T520-25zm0 263q84 0 126 71.5T688 496q0 114-42 185t-126 71q-83 0-125.5-71.5T352 496q0-115 42.5-186.5T520 238zm354 1017q0-63-44.5-107T721 1104q-63 0-107.5 44T569 1255q0 64 44.5 109t107.5 45q64 0 108.5-44.5T874 1255zm-401 0q0-63-44-107t-107-44q-64 0-109 44t-45 107q0 65 45 109.5t109 44.5q63 0 107-45t44-109z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "divide",
  unicode: "\xF7",
  horizAdvX: "907",
  d: "M588 1020q0-56-39-95.5T453 885q-55 0-94.5 39.5T319 1020q0 57 39 95t95 38q57 0 96-38t39-95zm260-418H59v178h789V602zM588 360q0-57-39-96t-96-39q-56 0-95 39t-39 96q0 56 39.5 95t94.5 39q57 0 96-39t39-95z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "oslash",
  unicode: "\xF8",
  horizAdvX: "1040",
  d: "M225 0H59l105 137Q47 278 47 496q0 105 31.5 198T168 858.5 317 972t203 42q144 0 256-72l35 47h168L874 854q119-143 119-358 0-105-31-198t-89-165.5-149.5-115T520-25q-146 0-258 72zm295 238q84 0 126 71.5T688 496q0 46-10 98L430 268q38-30 90-30zM352 496q0-60 8-99l248 326q-40 29-88 29-83 0-125.5-71.5T352 496z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ugrave",
  unicode: "\xF9",
  d: "M963 0H668v119Q626 60 546 17.5T373-25q-138 0-206.5 72.5T98 246v743h297V362q0-124 117-124 50 0 90.5 29t65.5 71v651h295V0zM696 1139H504l-277 295h256z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "uacute",
  unicode: "\xFA",
  d: "M963 0H668v119Q626 60 546 17.5T373-25q-138 0-206.5 72.5T98 246v743h297V362q0-124 117-124 50 0 90.5 29t65.5 71v651h295V0zM840 1434l-277-295H371l215 295h254z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ucircumflex",
  unicode: "\xFB",
  d: "M963 0H668v119Q626 60 546 17.5T373-25q-138 0-206.5 72.5T98 246v743h297V362q0-124 117-124 50 0 90.5 29t65.5 71v651h295V0zM821 1139H653l-123 172-116-172H246l153 295h263z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "udieresis",
  unicode: "\xFC",
  d: "M963 0H668v119Q626 60 546 17.5T373-25q-138 0-206.5 72.5T98 246v743h297V362q0-124 117-124 50 0 90.5 29t65.5 71v651h295V0zm-74 1255q0-63-45-107t-109-44q-63 0-107 44t-44 107q0 64 44 109t107 45q65 0 109.5-44.5T889 1255zm-402 0q0-63-44-107t-107-44q-64 0-109 44t-45 107q0 65 45 109.5t109 44.5q63 0 107-45t44-109z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "yacute",
  unicode: "\xFD",
  d: "M838 1434l-277-295H369l215 295h254zM479-401q-235 0-379 129L211-49q47-52 115.5-78.5T465-154q96 0 149.5 54.5T668 51v117q-42-59-122-101T373 25q-138 0-206.5 71.5T98 293v696h297V412q0-127 117-127 50 0 90.5 30t65.5 72v602h295V51q0-210-127-331T479-401z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "thorn",
  unicode: "\xFE",
  d: "M643-25q-161 0-248 142v-494H98v1743h297V874q89 140 248 140 171 0 272-137t101-381q0-242-101.5-381.5T643-25zM543 238q80 0 125 70t45 188q0 117-44.5 186.5T543 752q-42 0-83.5-24.5T395 662V328q21-39 63.5-64.5T543 238z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ydieresis",
  unicode: "\xFF",
  d: "M883 1255q0-63-45-107t-109-44q-63 0-107 44t-44 107q0 64 44 109t107 45q65 0 109.5-44.5T883 1255zm-402 0q0-63-44-107t-107-44q-64 0-109 44t-45 107q0 65 45 109.5t109 44.5q63 0 107-45t44-109zm-2-1656q-235 0-379 129L211-49q47-52 115.5-78.5T465-154q96 0 149.5 54.5T668 51v117q-42-59-122-101T373 25q-138 0-206.5 71.5T98 293v696h297V412q0-127 117-127 50 0 90.5 30t65.5 72v602h295V51q0-210-127-331T479-401z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "dotlessi",
  unicode: "\u0131",
  horizAdvX: "493",
  d: "M395 0H98v989h297V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Lslash",
  unicode: "\u0141",
  horizAdvX: "954",
  d: "M20 391v266l109 62v647h332V911l129 76V719l-129-76V289h444V0H129v453z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "lslash",
  unicode: "\u0142",
  horizAdvX: "622",
  d: "M20 420v213l123 69v664h297V872l123 72V733l-123-71V330q0-43 17.5-67.5T508 238q45 0 67 22l54-229q-67-56-205-56-281 0-281 283v231z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "OE",
  unicode: "\u0152",
  horizAdvX: "1777",
  d: "M1716 0H891v106Q844 43 762.5 9T598-25q-166 0-291 90.5t-190.5 250T51 682t65.5 366T307 1296.5t291 89.5q84 0 165-32.5t128-93.5v106h825v-289h-493V838h479V549h-479V289h493V0zM891 442v480q-31 84-93 128t-139 44q-130 0-200-113t-70-299q0-185 70-299.5T659 268q77 0 138.5 45T891 442z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "oe",
  unicode: "\u0153",
  horizAdvX: "1640",
  d: "M1602 397H985q10-80 65.5-131t153.5-51q51 0 109.5 23.5T1411 301l133-182q-68-70-168-107t-205-37q-116 0-193 46.5T840 150Q717-25 520-25q-148 0-257.5 73.5T100 238.5 47 496q0 105 31.5 198T168 858.5 317 972t203 42q192 0 322-174 114 174 313 174 209 0 328-147t119-386v-84zM983 600h336q-4 72-43.5 123T1151 774q-57 0-95.5-28t-54-64.5T983 600zM688 496q0 117-43.5 186.5T520 752t-124.5-69.5T352 496q0-119 43.5-189.5T520 236t124.5 70.5T688 496z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Scaron",
  unicode: "\u0160",
  horizAdvX: "1050",
  d: "M676 1491H414l-160 295h168l123-172 117 172h167zM518-25Q207-25 23 156l155 258q62-67 150-106.5T514 268q75 0 117.5 32t42.5 83q0 35-26.5 62.5t-69 45.5-97.5 39-112.5 41.5T256 627t-97.5 77.5-69 111T63 969q0 83 32 158t91.5 134 152.5 93.5 206 34.5q264 0 440-156L834 981q-127 115-299 115-64 0-99-29t-35-76q0-29 21-52t56-40.5 81-34.5 96.5-37T756 784t96-57 81-76.5T989 547t21-135q0-196-131.5-316.5T518-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "scaron",
  unicode: "\u0161",
  horizAdvX: "872",
  d: "M432-25q-125 0-232.5 39.5T25 119l118 207q53-49 132-84t149-35q63 0 95 21t32 57q0 26-27 43.5T454 358t-95.5 25-105 35.5T158 474t-70 91-27 135q0 132 101.5 223t283.5 91q213 0 367-127L698 682q-39 41-106.5 70.5T451 782q-49 0-81-20t-32-51q0-23 27.5-39t71-28 96.5-25.5T639 581t96.5-58 71-93T834 293q0-140-109.5-229T432-25zm141 1164H311l-159 295h167l123-172 117 172h168z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Ydieresis",
  unicode: "\u0178",
  horizAdvX: "1148",
  d: "M932 1612q0-63-45-107.5T778 1460q-63 0-107 44.5T627 1612q0 64 44 108.5t107 44.5q65 0 109.5-44.5T932 1612zm-402 0q0-63-44-107.5T379 1460q-64 0-109 44.5T225 1612q0 64 44.5 108.5T379 1765q63 0 107-44.5t44-108.5zM741 0H410v555l-426 811h362l229-508 228 508h362L741 555V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Zcaron",
  unicode: "\u017D",
  horizAdvX: "1019",
  d: "M643 1491H381l-160 295h168l123-172 117 172h168zM952 0H68v270l464 807H68v289h870v-264L469 289h483V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "zcaron",
  unicode: "\u017E",
  horizAdvX: "860",
  d: "M797 0H61v219l349 514H61v256h727V778L436 256h361V0zM555 1139H293l-160 295h168l123-172 117 172h168z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "florin",
  unicode: "\u0192",
  horizAdvX: "903",
  d: "M346-330H8l178 807H96v260h148l73 332q30 141 142.5 229t253.5 88q146 0 221-67l-100-254q-33 33-76 33t-75-29-44-80l-55-252h178V477H526z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "circumflex",
  unicode: "\u02C6",
  horizAdvX: "575",
  d: "M575 1139H408l-123 172-117-172H0l154 295h262z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "caron",
  unicode: "\u02C7",
  horizAdvX: "575",
  d: "M422 1139H160L0 1434h168l123-172 117 172h167z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "breve",
  unicode: "\u02D8",
  horizAdvX: "620",
  d: "M621 1290q-53-73-134.5-114T311 1135q-93 0-175 41T0 1290l131 103q68-95 180-95 55 0 102.5 25t78.5 70z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "dotaccent",
  unicode: "\u02D9",
  horizAdvX: "399",
  d: "M199 1116q-62 0-107 44.5T47 1268t45 108 107 45q63 0 108-45t45-108-45-107.5-108-44.5z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ring",
  unicode: "\u02DA",
  horizAdvX: "407",
  d: "M205 1118q-85 0-145 60T0 1323t60 145 145 60 144-60 59-145-59-145-144-60zm0 127q32 0 55 23t23 55-23 55-55 23-55-23-23-55 23-55 55-23z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ogonek",
  unicode: "\u02DB",
  horizAdvX: "376",
  d: "M260-203l117-67q-59-111-182-111-85 0-140 46T0-199Q0-47 164 66L264 0Q141-75 141-186q0-39 16-57.5t40-18.5q46 0 63 59z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "tilde",
  unicode: "\u02DC",
  horizAdvX: "622",
  d: "M414 1135q-40 0-73 19t-50.5 42-38.5 42-41 19q-59 0-59-110H0q0 128 55 201t154 73q33 0 60.5-12.5T315 1378t33.5-36.5 32-31T414 1298q26 0 42.5 28t16.5 83h150q0-129-54.5-201.5T414 1135z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "hungarumlaut",
  unicode: "\u02DD",
  horizAdvX: "657",
  d: "M362 1434l-202-295H0l139 295h223zm295 0l-202-295H295l139 295h223z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "pi",
  unicode: "\u03C0",
  horizAdvX: "1153",
  d: "M1006 0H709v764H444V0H147v764H41v260h1069V764h-104V0z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "endash",
  unicode: "\u2013",
  horizAdvX: "1079",
  d: "M1018 371H61v250h957V371z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "emdash",
  unicode: "\u2014",
  horizAdvX: "1509",
  d: "M1448 371H61v250h1387V371z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "quoteleft",
  unicode: "\u2018",
  horizAdvX: "542",
  d: "M74 987q0 119 60 223t167 179l123-103q-52-26-103-82.5T256 1092q16 8 45 8 64 0 108-45.5T453 938q0-73-53.5-126.5T274 758q-82 0-141 62.5T74 987z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "quoteright",
  unicode: "\u2019",
  horizAdvX: "542",
  d: "M465 1159q0-119-60-223.5T240 756L115 858q51 26 102 83.5t66 111.5q-9-6-43-6-64 0-108 44t-44 115q0 75 52 127.5t126 52.5q82 0 140.5-62t58.5-165z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "quotesinglbase",
  unicode: "\u201A",
  horizAdvX: "542",
  d: "M465 115q0-119-60-223.5T240-287L115-186q52 28 103 84.5T283 8q-18-6-43-6-64 0-108 45.5T88 164q0 74 52 126t126 52q82 0 140.5-61.5T465 115z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "quotedblleft",
  unicode: "\u201C",
  horizAdvX: "989",
  d: "M78 987q0 119 59.5 223T303 1389l123-103q-52-26-103-82.5T258 1092q16 8 45 8 64 0 108-45.5T455 938q0-73-53.5-126.5T276 758q-82 0-140 62T78 987zm444 0q0 119 60 222.5T748 1389l124-103q-52-26-102.5-82.5T705 1092q16 8 45 8 64 0 107.5-45.5T901 938q0-73-53-126.5T723 758q-83 0-142 62t-59 167z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "quotedblright",
  unicode: "\u201D",
  horizAdvX: "989",
  d: "M911 1159q0-119-60-223.5T686 756L561 858q51 26 102 83.5t66 111.5q-12-6-45-6-64 0-108 44t-44 115q0 74 53 127t126 53q83 0 141.5-62t58.5-165zm-446 0q0-119-60-223.5T240 756L115 858q51 26 102 83.5t66 111.5q-9-6-43-6-64 0-108 44t-44 115q0 75 52 127.5t126 52.5q82 0 140.5-62t58.5-165z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "quotedblbase",
  unicode: "\u201E",
  horizAdvX: "989",
  d: "M465 115q0-119-60-223.5T240-287L115-186q52 28 103 84.5T283 8q-18-6-43-6-64 0-108 45.5T88 164q0 74 52 126t126 52q82 0 140.5-61.5T465 115zm446 0q0-119-60-223.5T686-287L561-186q52 28 103 84.5T729 8q-24-6-45-6-64 0-108 45.5T532 164q0 73 53.5 125.5T711 342q83 0 141.5-61T911 115z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "dagger",
  unicode: "\u2020",
  horizAdvX: "577",
  d: "M539 1063l-183 8 9-401H211l10 401-182-8v139l182-6-10 190h154l-9-190 183 6v-139z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "daggerdbl",
  unicode: "\u2021",
  horizAdvX: "577",
  d: "M539 1202v-139l-183 8V686l183 8V555l-183 6 9-192H211l8 192-180-6v139l180-8v385l-180-8v139l180-6-8 190h154l-9-190z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "bullet",
  unicode: "\u2022",
  horizAdvX: "733",
  d: "M618 496q0-103-72.5-175.5T369 248t-177 72.5T119 496q0 104 73 176.5T369 745t176.5-72.5T618 496z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "ellipsis",
  unicode: "\u2026",
  horizAdvX: "1622",
  d: "M453 160q0-74-54-128.5T270-23 141.5 31.5 88 160t53.5 128T270 342t129-54 54-128zm540 0q0-74-53.5-128.5T811-23 682.5 31.5 629 160t53.5 128T811 342t128.5-54T993 160zm541 0q0-74-53.5-128.5T1352-23t-129 54.5-54 128.5 54 128 129 54 128.5-54 53.5-128z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "perthousand",
  unicode: "\u2030",
  horizAdvX: "2068",
  d: "M672 1042q0-146-87.5-243T354 702q-142 0-228.5 97T39 1042q0 148 86.5 246t228.5 98q143 0 230.5-98t87.5-246zm465 324L410 0H266l725 1366h146zm223-1051q0-145-88-242.5T1042-25 813.5 72 727 315q0 148 86.5 246t228.5 98 230-98 88-246zm-885 727q0 83-33.5 129t-87.5 46q-52 0-84-46t-32-129q0-80 32-125t84-45q54 0 87.5 45t33.5 125zm688-727q0 83-33.5 128.5T1042 489t-86-45.5T924 315q0-80 32-125t86-45 87.5 45 33.5 125zm867 0q0-145-88-242.5T1712-25t-228.5 97-86.5 243q0 148 86.5 246t228.5 98 230-98 88-246zm-197 0q0 83-33.5 128.5T1712 489t-86.5-45.5T1593 315q0-80 32.5-125t86.5-45 87.5 45 33.5 125z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "guilsinglleft",
  unicode: "\u2039",
  horizAdvX: "624",
  d: "M563 129H317L61 498l256 362h246L307 498z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "guilsinglright",
  unicode: "\u203A",
  horizAdvX: "624",
  d: "M563 498L307 129H61l256 369L61 860h246z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "fraction",
  unicode: "\u2044",
  horizAdvX: "319",
  d: "M594 1366L-133 0h-141l725 1366h143z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Euro",
  unicode: "\u20AC",
  horizAdvX: "1216",
  d: "M705-25q-222 0-374.5 128T123 453H33v178h63v51q0 37 2 55H33v181h92q55 218 207.5 344.5T705 1389q83 0 154-22t120.5-55.5 92-83 69-96T1190 1030L918 913q-29 83-84 133t-129 50q-78 0-138-46.5T473 918h315V737H436q-2-18-2-55 0-35 2-51h352V453H471q34-88 94-136.5T705 268q75 0 132 55t81 142l272-117Q1050-25 705-25z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "trademark",
  unicode: "\u2122",
  horizAdvX: "847",
  d: "M776 915h-57v373L586 915h-17l-133 373V915h-57v451h88l111-324 110 324h88V915zm-471 398H199V915h-58v398H35v53h270v-53z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Omega",
  unicode: "\u2126",
  horizAdvX: "1300",
  d: "M80 0v289h209q-108 84-174 205T49 760q0 286 162.5 457.5T649 1389q277 0 439.5-171T1251 760q0-145-66.5-266T1010 289h211V0H735v289q79 28 128.5 146.5T913 684q0 86-15 158.5t-45.5 130T770 1062t-121 32q-68 0-119.5-32t-82-89.5-45.5-130T387 684q0-132 49.5-251T565 289V0H80z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "partialdiff",
  unicode: "\u2202",
  horizAdvX: "1040",
  d: "M520-25q-112 0-203 39T168 119.5 78.5 272 47 455q0 197 106.5 336T426 930q174 0 260-154-82 308-315 490l241 135q80-76 146.5-166.5t120.5-201T963 789t30-277q0-242-123.5-389.5T520-25zm0 263q83 0 125.5 59T688 453q0 98-42.5 157.5T520 670q-82 0-125-59.5T352 453q0-96 43-155.5T520 238z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "Delta",
  unicode: "\u2206",
  horizAdvX: "1196",
  d: "M1208 0H-12l411 1366h398zM786 289l-188 733-188-733h376z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "product",
  unicode: "\u220F",
  horizAdvX: "1427",
  d: "M1231-184H899v1261H528V-184H197v1261H41v289h1343v-289h-153V-184z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "summation",
  unicode: "\u2211",
  horizAdvX: "1001",
  d: "M455 1077l305-471-320-502h490v-288H74v297l311 495-309 469v289h854v-289H455z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "minus",
  unicode: "\u2212",
  horizAdvX: "913",
  d: "M854 596H59v178h795V596z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "radical",
  unicode: "\u221A",
  horizAdvX: "1161",
  d: "M702 0H512L338 600l-207-59-43 174 381 102 141-524 310 1073h198z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "infinity",
  unicode: "\u221E",
  horizAdvX: "1234",
  d: "M354 317q-76 0-134.5 32.5t-92.5 87-51 118T59 688t17 133.5 51 118 92.5 87T354 1059q89 0 156-54.5T616 860q38 88 108 142.5t155 54.5q77 0 136-32.5t93-87 51-118 17-133.5q0-55-10-107t-33-100-57-83.5-84.5-57T879 317q-85 0-155 54.5T616 514q-39-90-105.5-143.5T354 317zm498 179q62 0 101.5 51.5T993 686q0 88-39.5 141.5T852 881q-54 0-94-54t-62-141q22-85 62-137.5t94-52.5zm-469-2q54 0 94.5 53T541 688q-24 86-64 139.5T383 881q-63 0-103-52.5T240 688t40-141 103-53z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "integral",
  unicode: "\u222B",
  horizAdvX: "647",
  d: "M125-205H35v193h90q39 0 66.5 31T219 98v1172q0 133 90.5 218t214.5 85h88v-193h-88q-41 0-68.5-30t-27.5-80V96q0-132-90-216.5T125-205z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "approxequal",
  unicode: "\u2248",
  horizAdvX: "913",
  d: "M59 403v191q86-51 199-51 56 0 105.5 13.5t82 30.5 88 30.5T655 631q113 0 199-39V401q-88 52-199 52-56 0-105.5-13.5t-82-30.5-88-30.5T258 365q-115 0-199 38zm0 373v191q88-52 199-52 56 0 105.5 14t82 30.5 88 30.5 121.5 14q113 0 199-39V774q-86 51-199 51-56 0-105.5-13.5t-82-30.5-88-30.5T258 737q-113 0-199 39z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "notequal",
  unicode: "\u2260",
  horizAdvX: "913",
  d: "M266 190H123l113 213H59v179h271l108 204H59v179h473l113 211h146L678 965h176V786H584L475 582h379V403H379z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "lessequal",
  unicode: "\u2264",
  horizAdvX: "913",
  d: "M854 270L59 602v213l795 334V936L264 707l590-224V270zm0-256H59v179h795V14z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "greaterequal",
  unicode: "\u2265",
  horizAdvX: "913",
  d: "M854 602L59 270v213l590 224L59 936v213l795-334V602zm0-588H59v179h795V14z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "lozenge",
  unicode: "\u25CA",
  horizAdvX: "768",
  d: "M406 0h-44L39 684l323 682h44l323-682zm-21 84l270 600-272 598-270-598z"
}), /*#__PURE__*/React.createElement("glyph", {
  glyphName: "apple",
  unicode: "\uF8FF",
  horizAdvX: "1366",
  d: "M442 315v129H313q-54 0-91.5-38T184 315q0-55 37.5-93t91.5-38 91.5 38 37.5 93zm0 607v131q0 54-37 91.5t-90 37.5q-55 0-93-37.5t-38-91.5 38-92.5 93-38.5h127zm101-379h280v280H543V543zm639-228q0 53-37.5 91t-91.5 38H924V315q0-55 37.5-93t91.5-38 91.5 38 37.5 93zm0 738q0 54-38 91.5t-91 37.5q-54 0-91.5-37.5T924 1053V922h129q53 0 91 38.5t38 92.5zm98-738q0-94-66.5-161.5T1053 86t-162 67.5T823 315v129H543V315q0-94-68-161.5T313 86t-160.5 67.5T86 315t66.5 161T313 543h129v280H315q-94 0-161.5 68T86 1053t67.5 160.5T315 1280t161-66.5 67-160.5V922h280v131q0 93 68 160t162 67 160.5-66.5T1280 1053t-67-162-160-68H924V543h129q94 0 160.5-67t66.5-161z"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "a",
  u2: "\u0178",
  k: "139"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "a",
  u2: "\xDD",
  k: "139"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "a",
  u2: "Y",
  k: "139"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "a",
  u2: "W",
  k: "49"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "a",
  u2: "V",
  k: "86"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "a",
  u2: "T",
  k: "88"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "a",
  u2: "?",
  k: "51"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "\u2122",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "\u201D",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "\u201C",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "\u2019",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "\u2018",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "\u0178",
  k: "170"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "\xDD",
  k: "170"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "\xAE",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "Y",
  k: "170"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "W",
  k: "80"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "V",
  k: "111"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "T",
  k: "141"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "?",
  k: "80"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "'",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "h",
  u2: "\"",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "\u2122",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "\u201D",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "\u201C",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "\u2019",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "\u2018",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "\u0178",
  k: "170"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "\xDD",
  k: "170"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "\xAE",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "Y",
  k: "170"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "W",
  k: "80"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "V",
  k: "111"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "T",
  k: "141"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "?",
  k: "80"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "'",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "m",
  u2: "\"",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  u1: "\xC3",
  u2: "w",
  k: "20"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "asterisk",
  k: "135"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "question",
  k: "106"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
  k: "45"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "J",
  k: "-31"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "T",
  k: "100"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "V",
  k: "70"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "W",
  k: "59"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "Y,Yacute,Ydieresis",
  k: "102"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "t",
  k: "39"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "v",
  k: "37"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "dagger",
  k: "141"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "quotedbl,quotesingle,registered,quoteleft,quoteright,quotedblleft,quotedblright,trademark",
  k: "145"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "daggerdbl",
  k: "49"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Delta",
  g2: "f,fi,fl",
  k: "31"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "B",
  g2: "V",
  k: "29"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "B",
  g2: "Y,Yacute,Ydieresis",
  k: "51"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "C,Ccedilla",
  g2: "Y,Yacute,Ydieresis",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn",
  g2: "question",
  k: "31"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn",
  g2: "J",
  k: "41"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn",
  g2: "T",
  k: "33"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn",
  g2: "V",
  k: "29"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn",
  g2: "W",
  k: "29"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn",
  g2: "Y,Yacute,Ydieresis",
  k: "68"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn",
  g2: "quotedbl,quotesingle,registered,quoteleft,quoteright,quotedblleft,quotedblright,trademark",
  k: "29"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn",
  g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Delta",
  k: "45"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn",
  g2: "X",
  k: "49"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn",
  g2: "Z,Zcaron",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "F",
  g2: "J",
  k: "143"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "F",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "113"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "F",
  g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Delta",
  k: "70"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "F",
  g2: "ampersand",
  k: "39"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "G",
  g2: "V",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "G",
  g2: "Y,Yacute,Ydieresis",
  k: "47"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "K",
  g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
  k: "74"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "K",
  g2: "t",
  k: "82"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "K",
  g2: "v",
  k: "102"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "K",
  g2: "f,fi,fl",
  k: "57"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "K",
  g2: "hyphen,periodcentered,endash,emdash",
  k: "80"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "K",
  g2: "c,d,e,g,o,q,ccedilla,eth,oslash,oe",
  k: "55"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "K",
  g2: "u",
  k: "33"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "K",
  g2: "w",
  k: "82"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "K",
  g2: "x",
  k: "59"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "K",
  g2: "a,ae",
  k: "55"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "K",
  g2: "y,yacute,ydieresis",
  k: "33"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "L,Lslash",
  g2: "asterisk",
  k: "268"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "L,Lslash",
  g2: "question",
  k: "150"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "L,Lslash",
  g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
  k: "49"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "L,Lslash",
  g2: "T",
  k: "150"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "L,Lslash",
  g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "L,Lslash",
  g2: "V",
  k: "152"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "L,Lslash",
  g2: "W",
  k: "125"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "L,Lslash",
  g2: "Y,Yacute,Ydieresis",
  k: "215"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "L,Lslash",
  g2: "t",
  k: "59"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "L,Lslash",
  g2: "v",
  k: "102"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "L,Lslash",
  g2: "dagger",
  k: "209"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "L,Lslash",
  g2: "quotedbl,quotesingle,registered,quoteleft,quoteright,quotedblleft,quotedblright,trademark",
  k: "262"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "L,Lslash",
  g2: "daggerdbl",
  k: "143"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "L,Lslash",
  g2: "w",
  k: "63"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "P",
  g2: "J",
  k: "219"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "P",
  g2: "Y,Yacute,Ydieresis",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "P",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "178"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "P",
  g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Delta",
  k: "109"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "P",
  g2: "X",
  k: "55"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "P",
  g2: "ampersand",
  k: "57"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "P",
  g2: "hyphen,periodcentered,endash,emdash",
  k: "49"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "P",
  g2: "c,d,e,g,o,q,ccedilla,eth,oslash,oe",
  k: "39"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "P",
  g2: "a,ae",
  k: "39"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "R",
  g2: "Y,Yacute,Ydieresis",
  k: "35"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "R",
  g2: "ampersand",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "R",
  g2: "c,d,e,g,o,q,ccedilla,eth,oslash,oe",
  k: "51"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "R",
  g2: "a,ae",
  k: "51"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "R",
  g2: "s",
  k: "27"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "S,Scaron",
  g2: "T",
  k: "31"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "S,Scaron",
  g2: "t",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "S,Scaron",
  g2: "v",
  k: "31"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "S,Scaron",
  g2: "x",
  k: "29"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
  k: "33"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "J",
  k: "150"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "v",
  k: "29"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "f,fi,fl",
  k: "35"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "166"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Delta",
  k: "100"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "ampersand",
  k: "92"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "hyphen,periodcentered,endash,emdash",
  k: "111"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "c,d,e,g,o,q,ccedilla,eth,oslash,oe",
  k: "145"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "u",
  k: "88"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "w",
  k: "29"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "x",
  k: "47"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "a,ae",
  k: "145"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "y,yacute,ydieresis",
  k: "88"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "s",
  k: "121"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "colon,semicolon",
  k: "94"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "T",
  g2: "m,n,p,r,z",
  k: "88"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "J,U,Ugrave,Uacute,Ucircumflex,Udieresis",
  g2: "J",
  k: "63"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "J,U,Ugrave,Uacute,Ucircumflex,Udieresis",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "45"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "J,U,Ugrave,Uacute,Ucircumflex,Udieresis",
  g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Delta",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
  k: "29"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "J",
  k: "154"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "t",
  k: "29"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "v",
  k: "27"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "f,fi,fl",
  k: "37"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "160"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Delta",
  k: "70"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "ampersand",
  k: "76"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "hyphen,periodcentered,endash,emdash",
  k: "98"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "c,d,e,g,o,q,ccedilla,eth,oslash,oe",
  k: "94"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "u",
  k: "86"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "w",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "x",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "a,ae",
  k: "94"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "y,yacute,ydieresis",
  k: "86"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "s",
  k: "90"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "V",
  g2: "m,n,p,r,z",
  k: "86"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
  k: "29"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "J",
  k: "119"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "t",
  k: "33"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "f,fi,fl",
  k: "33"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "113"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Delta",
  k: "59"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "ampersand",
  k: "47"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "hyphen,periodcentered,endash,emdash",
  k: "63"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "c,d,e,g,o,q,ccedilla,eth,oslash,oe",
  k: "70"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "u",
  k: "49"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "x",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "a,ae",
  k: "70"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "y,yacute,ydieresis",
  k: "49"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "s",
  k: "68"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "W",
  g2: "m,n,p,r,z",
  k: "49"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
  k: "68"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "J",
  k: "193"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "t",
  k: "61"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "v",
  k: "104"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "f,fi,fl",
  k: "98"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "182"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Delta",
  k: "102"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "ampersand",
  k: "104"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "hyphen,periodcentered,endash,emdash",
  k: "211"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "c,d,e,g,o,q,ccedilla,eth,oslash,oe",
  k: "201"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "u",
  k: "139"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "w",
  k: "98"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "x",
  k: "115"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "a,ae",
  k: "201"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "y,yacute,ydieresis",
  k: "139"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "s",
  k: "172"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "colon,semicolon",
  k: "121"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "m,n,p,r,z",
  k: "139"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Y,Yacute,Ydieresis",
  g2: "S,Scaron",
  k: "29"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "Z,Zcaron",
  g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "h,m,n",
  g2: "question",
  k: "80"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "h,m,n",
  g2: "T",
  k: "141"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "h,m,n",
  g2: "V",
  k: "111"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "h,m,n",
  g2: "W",
  k: "80"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "h,m,n",
  g2: "Y,Yacute,Ydieresis",
  k: "170"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "h,m,n",
  g2: "quotedbl,quotesingle,registered,quoteleft,quoteright,quotedblleft,quotedblright,trademark",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "ampersand",
  g2: "T",
  k: "94"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "ampersand",
  g2: "V",
  k: "82"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "ampersand",
  g2: "W",
  k: "45"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "ampersand",
  g2: "Y,Yacute,Ydieresis",
  k: "131"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "asterisk",
  g2: "J",
  k: "211"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "asterisk",
  g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Delta",
  k: "135"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "b,o,p,oslash,thorn",
  g2: "question",
  k: "84"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "b,o,p,oslash,thorn",
  g2: "T",
  k: "145"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "b,o,p,oslash,thorn",
  g2: "V",
  k: "94"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "b,o,p,oslash,thorn",
  g2: "W",
  k: "70"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "b,o,p,oslash,thorn",
  g2: "Y,Yacute,Ydieresis",
  k: "193"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "b,o,p,oslash,thorn",
  g2: "x",
  k: "51"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "c,cent,ccedilla",
  g2: "question",
  k: "35"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "c,cent,ccedilla",
  g2: "T",
  k: "96"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "c,cent,ccedilla",
  g2: "V",
  k: "61"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "c,cent,ccedilla",
  g2: "W",
  k: "47"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "c,cent,ccedilla",
  g2: "Y,Yacute,Ydieresis",
  k: "109"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "colon,semicolon",
  g2: "T",
  k: "94"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "colon,semicolon",
  g2: "Y,Yacute,Ydieresis",
  k: "121"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "e,ae,oe",
  g2: "asterisk",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "e,ae,oe",
  g2: "question",
  k: "70"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "e,ae,oe",
  g2: "T",
  k: "131"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "e,ae,oe",
  g2: "V",
  k: "82"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "e,ae,oe",
  g2: "W",
  k: "70"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "e,ae,oe",
  g2: "Y,Yacute,Ydieresis",
  k: "176"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "f",
  g2: "asterisk",
  k: "-102"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "f",
  g2: "question",
  k: "-100"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "f",
  g2: "T",
  k: "-80"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "f",
  g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
  k: "-72"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "f",
  g2: "V",
  k: "-113"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "f",
  g2: "W",
  k: "-111"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "f",
  g2: "Y,Yacute,Ydieresis",
  k: "-111"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "f",
  g2: "quotedbl,quotesingle,registered,quoteleft,quoteright,quotedblleft,quotedblright,trademark",
  k: "-88"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "f",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "80"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "f",
  g2: "X",
  k: "-78"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "f",
  g2: "Z,Zcaron",
  k: "-78"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "f",
  g2: "S,Scaron",
  k: "-51"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "f",
  g2: "exclam,B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Lslash",
  k: "-72"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "f",
  g2: "parenright,bracketright,braceright",
  k: "-115"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "g,q",
  g2: "question",
  k: "39"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "g,q",
  g2: "T",
  k: "88"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "g,q",
  g2: "V",
  k: "86"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "g,q",
  g2: "W",
  k: "49"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "g,q",
  g2: "Y,Yacute,Ydieresis",
  k: "139"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "g,q",
  g2: "j",
  k: "-63"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "hyphen,periodcentered,endash,emdash",
  g2: "V",
  k: "98"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "hyphen,periodcentered,endash,emdash",
  g2: "W",
  k: "63"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "hyphen,periodcentered,endash,emdash",
  g2: "Y,Yacute,Ydieresis",
  k: "209"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "hyphen,periodcentered,endash,emdash",
  g2: "X",
  k: "74"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "k",
  g2: "T",
  k: "55"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "k",
  g2: "V",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "k",
  g2: "W",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "k",
  g2: "Y,Yacute,Ydieresis",
  k: "113"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "k",
  g2: "hyphen,periodcentered,endash,emdash",
  k: "33"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "k",
  g2: "c,d,e,g,o,q,ccedilla,eth,oslash,oe",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "k",
  g2: "a,ae",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "k",
  g2: "bullet",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  g2: "T",
  k: "166"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
  k: "45"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  g2: "V",
  k: "152"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  g2: "W",
  k: "113"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  g2: "Y,Yacute,Ydieresis",
  k: "182"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  g2: "t",
  k: "39"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  g2: "v",
  k: "111"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  g2: "quotedbl,quotesingle,registered,quoteleft,quoteright,quotedblleft,quotedblright,trademark",
  k: "166"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  g2: "f,fi,fl",
  k: "39"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  g2: "w",
  k: "74"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  g2: "j",
  k: "-41"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  g2: "zero,six",
  k: "39"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  g2: "one",
  k: "225"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  g2: "seven",
  k: "115"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "questiondown",
  g2: "j",
  k: "-260"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
  g2: "J",
  k: "203"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "166"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
  g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Delta",
  k: "150"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
  g2: "s",
  k: "63"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "r",
  g2: "T",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "r",
  g2: "V",
  k: "37"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "r",
  g2: "W",
  k: "31"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "r",
  g2: "Y,Yacute,Ydieresis",
  k: "84"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "r",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "160"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "r",
  g2: "X",
  k: "47"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "s",
  g2: "question",
  k: "66"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "s",
  g2: "T",
  k: "100"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "s",
  g2: "V",
  k: "63"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "s",
  g2: "W",
  k: "80"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "s",
  g2: "Y,Yacute,Ydieresis",
  k: "143"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "s",
  g2: "quotedbl,quotesingle,registered,quoteleft,quoteright,quotedblleft,quotedblright,trademark",
  k: "39"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "t",
  g2: "T",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "t",
  g2: "V",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "t",
  g2: "W",
  k: "33"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "t",
  g2: "Y,Yacute,Ydieresis",
  k: "68"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "u,z",
  g2: "question",
  k: "51"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "u,z",
  g2: "T",
  k: "88"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "u,z",
  g2: "V",
  k: "86"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "u,z",
  g2: "W",
  k: "49"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "u,z",
  g2: "Y,Yacute,Ydieresis",
  k: "139"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "v",
  g2: "T",
  k: "29"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "v",
  g2: "V",
  k: "27"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "v",
  g2: "Y,Yacute,Ydieresis",
  k: "104"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "v",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "111"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "v",
  g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Delta",
  k: "37"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "v",
  g2: "X",
  k: "63"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "w",
  g2: "T",
  k: "29"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "w",
  g2: "V",
  k: "23"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "w",
  g2: "Y,Yacute,Ydieresis",
  k: "98"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "w",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "74"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "w",
  g2: "X",
  k: "68"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "y,yacute,ydieresis",
  g2: "question",
  k: "39"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "y,yacute,ydieresis",
  g2: "T",
  k: "88"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "y,yacute,ydieresis",
  g2: "V",
  k: "86"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "y,yacute,ydieresis",
  g2: "W",
  k: "49"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "y,yacute,ydieresis",
  g2: "Y,Yacute,Ydieresis",
  k: "139"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "y,yacute,ydieresis",
  g2: "j",
  k: "-63"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "X",
  g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
  k: "49"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "X",
  g2: "t",
  k: "47"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "X",
  g2: "v",
  k: "63"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "X",
  g2: "f,fi,fl",
  k: "47"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "X",
  g2: "hyphen,periodcentered,endash,emdash",
  k: "74"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "X",
  g2: "w",
  k: "68"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "zero,nine",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "39"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "seven",
  g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
  k: "172"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "x",
  g2: "T",
  k: "47"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "x",
  g2: "V",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "x",
  g2: "W",
  k: "43"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "x",
  g2: "Y,Yacute,Ydieresis",
  k: "115"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "x",
  g2: "c,d,e,g,o,q,ccedilla,eth,oslash,oe",
  k: "51"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "x",
  g2: "a,ae",
  k: "51"
}), /*#__PURE__*/React.createElement("hkern", {
  g1: "parenleft,bracketleft,braceleft",
  g2: "j",
  k: "-172"
}))));